import cityPref from './cityPref.json';
import { Timestamp, DocumentSnapshot, DocumentData } from "firebase/firestore";

export type FirestoreDate = Date | Timestamp;

export const defaultRecruitData: recruitData = {
  companyId: '',
  name: '',
  title: '',
  image: [ '', '', '', '', '', ],

  point1: '',
  point2: '',
  point3: '',

  numberTags: [],
  number1: 0,
  number2: 0,
  number3: 0,
  number4: 0,
  number5: 0,
  number6: 0,
  number7: 0,
  number8: 0,
  number9: 0,
  number10: 0,
  number11: 0,
  number12: 0,
  number13: 0,

  imageCount:  0,
  image1FilesName: [],
  image1Title: '',
  image1Desc: '',

  image2FilesName: [],
  image2Title: '',
  image2Desc: '',

  image3FilesName: [],
  image3Title: '',
  image3Desc: '',

  interviewCount:  2,
  interview1Name: '',
  interview1Title: '',
  interview1Desc: '',
  interview2Name: '',
  interview2Title: '',
  interview2Desc: '',
  interview3Name: '',
  interview3Title: '',
  interview3Desc: '',
  interview4Name: '',
  interview4Title: '',
  interview4Desc: '',
  interview5Name: '',
  interview5Title: '',
  interview5Desc: '',
  interview6Name: '',
  interview6Title: '',
  interview6Desc: '',

  person1: 0,
  person2: 0,
  person3: 0,
  person4: 0,
  person5: 0,

  employmentStatus: '',
  monthlySalaryStart: '',
  annualIncomeStart: '',
  annualIncomeEnd: '',
  workingHoursStart: '',
  workingHoursEnd: '',

  overtime: false,
  overtimeOther: '',
  welfare: [],
  welfareCheck: false,
  welfareOther: '',
  salaryWelfare: '',
  holiday: [],
  holidayCheck: false,
  holidayOther: '',
};

export type recruitData = {
  companyId: string;
  name: string;
  title: string;
  image: string[];

  point1: string;
  point2: string;
  point3: string;

  numberTags: string[];
  number1: number;
  number2: number;
  number3: number;
  number4: number;
  number5: number;
  number6: number;
  number7: number;
  number8: number;
  number9: number;
  number10: number;
  number11: number;
  number12: number;
  number13: number;

  imageCount: number;
  image1FilesName: string[];
  image1Title: string;
  image1Desc: string;
  image2FilesName: string[];
  image2Title: string;
  image2Desc: string;
  image3FilesName: string[];
  image3Title: string;
  image3Desc: string;

  interviewCount: number;
  interview1Name: string;
  interview1Title: string;
  interview1Desc: string;
  interview2Name: string;
  interview2Title: string;
  interview2Desc: string;
  interview3Name: string;
  interview3Title: string;
  interview3Desc: string;
  interview4Name: string;
  interview4Title: string;
  interview4Desc: string;
  interview5Name: string;
  interview5Title: string;
  interview5Desc: string;
  interview6Name: string;
  interview6Title: string;
  interview6Desc: string;

  person1: number;
  person2: number;
  person3: number;
  person4: number;
  person5: number;

  employmentStatus: string;
  monthlySalaryStart: string;
  annualIncomeStart: string;
  annualIncomeEnd: string;
  workingHoursStart: string;
  workingHoursEnd: string;

  overtime: boolean;
  overtimeOther: string;
  welfare: string[];
  welfareCheck: boolean;
  welfareOther: string;
  salaryWelfare: string;
  holiday: string[];
  holidayCheck: boolean;
  holidayOther: string;
}

export const defaultSummaryData: summaryData = {
  isCompleted: false,
  name: '',
  companyPr: '',
  title: '',
  images: [],
};

export type summaryData = {
  isCompleted: boolean,
  name: string,
  companyPr: string,
  title: string,
  images: string[],
};

export const formatSummary = (docData: any): summaryData => ({
  ...defaultSummaryData,
  isCompleted: docData.summary?.isCompleted ??  true,
  companyPr: docData.summary?.companyPr ?? '',
  name: docData.summary?.name ?? '',
  title: docData.summary?.title ?? '',
  images: docData.summary?.images ?? [],
});

export type pointData = {
  isCompleted: boolean,
  title1: string,
  title2: string,
  title3: string,
};

export const defaultPointData: pointData = {
  isCompleted: false,
  title1: '',
  title2: '',
  title3: '',
};

export const formatPoint = (docData: any): pointData => ({
  ...defaultPointData,
  isCompleted: docData.point?.isCompleted ?? false,
  title1: docData.point?.title1 ?? '',
  title2: docData.point?.title2 ?? '',
  title3: docData.point?.title3 ?? '',
});

export type numberData = {
  isCompleted: boolean,
  tags: string[],
  text1: string;
  text2: string;
  text3: string;
  text4: string;
  text5: string;
  text6: string;
  text7: string;
  text8: string;
  text9: string;
  text10: string;
  text11: string;
  text12: string;
  text13: string;
};

export const defaultNumberData: numberData = {
  isCompleted: false,
  tags: [],
  text1: '',
  text2: '',
  text3: '',
  text4: '',
  text5: '',
  text6: '',
  text7: '',
  text8: '',
  text9: '',
  text10: '',
  text11: '',
  text12: '',
  text13: '',
};

export const formatNumber = (docData: any): numberData => ({
  ...defaultNumberData,
  isCompleted: docData.number?.isCompleted ?? false,
  tags: docData.number?.tags ?? [],
  text1: docData.number?.text1 ?? '',
  text2: docData.number?.text2 ?? '',
  text3: docData.number?.text3 ?? '',
  text4: docData.number?.text4 ?? '',
  text5: docData.number?.text5 ?? '',
  text6: docData.number?.text6 ?? '',
  text7: docData.number?.text7 ?? '',
  text8: docData.number?.text8 ?? '',
  text9: docData.number?.text9 ?? '',
  text10: docData.number?.text10 ?? '',
  text11: docData.number?.text11 ?? '',
  text12: docData.number?.text12 ?? '',
  text13: docData.number?.text13 ?? '',
});

export type strongData = {
  isCompleted: boolean,
  item1: {
    title: string,
    desc: string,
    images: string[],
  },
  item2: {
    title: string,
    desc: string,
    images: string[],
  },
  item3: {
    title: string,
    desc: string,
    images: string[],
  },
};

export const defaultStrongData: strongData = {
  isCompleted: false,
  item1: {
    title: '',
    desc: '',
    images: [],
  },
  item2: {
    title: '',
    desc: '',
    images: [],
  },
  item3: {
    title: '',
    desc: '',
    images: [],
  },
};

const safeStringArray = (v: any): string[] => {
  if (!Array.isArray(v)) return [];
  return v.filter((x): x is string => typeof x === "string");
};

export const formatStrong = (docData: any): strongData => ({
  ...defaultStrongData,
  isCompleted: docData.strong?.isCompleted ?? false,

  item1: {
    title: docData.strong?.item1?.title ?? '',
    desc: docData.strong?.item1?.desc ?? '',
    images: safeStringArray(docData.strong?.item1?.images),
  },

  item2: {
    title: docData.strong?.item2?.title ?? '',
    desc: docData.strong?.item2?.desc ?? '',
    images: safeStringArray(docData.strong?.item2?.images),
  },

  item3: {
    title: docData.strong?.item3?.title ?? '',
    desc: docData.strong?.item3?.desc ?? '',
    images: safeStringArray(docData.strong?.item3?.images),
  },
});

// export const formatStrong = (docData: any): strongData => ({
//   ...defaultStrongData,
//   isCompleted: docData.strong?.isCompleted ?? false,
//   item1: { 
//     title: docData.strong?.item1.title ?? '',
//     desc: docData.strong?.item1.desc ?? '',
//     images: docData.strong?.item1.images ?? []
//   },
//   item2: { 
//     title: docData.strong?.item2.title ?? '',
//     desc: docData.strong?.item2.desc ?? '',
//     images: docData.strong?.item2.images ?? []
//   },
//   item3: { 
//     title: docData.strong?.item3.title ?? '',
//     desc: docData.strong?.item3.desc ?? '',
//     images: docData.strong?.item3.images ?? []
//   },
// });

export type interviewsData = {
  isCompleted: boolean,
  count: number,
  item1: {
    name: string,
    title: string,
    desc: string,
    image: string,
  },
  item2: {
    name: string,
    title: string,
    desc: string,
    image: string,
  },
  item3: {
    name: string,
    title: string,
    desc: string,
    image: string,
  },
  item4: {
    name: string,
    title: string,
    desc: string,
    image: string,
  },
  item5: {
    name: string,
    title: string,
    desc: string,
    image: string,
  },
  item6: {
    name: string,
    title: string,
    desc: string,
    image: string,
  },
};

export const defaultInterviewsData: interviewsData = {
  isCompleted: false,
  count: 2,
  item1: {
    name: '',
    title: '',
    desc: '',
    image: '',
  },
  item2: {
    name: '',
    title: '',
    desc: '',
    image: '',
  },
  item3: {
    name: '',
    title: '',
    desc: '',
    image: '',
  },
  item4: {
    name: '',
    title: '',
    desc: '',
    image: '',
  },
  item5: {
    name: '',
    title: '',
    desc: '',
    image: '',
  },
  item6: {
    name: '',
    title: '',
    desc: '',
    image: '',
  },
};


export const formatInterviews = (docData: any): interviewsData => ({
  ...defaultInterviewsData,
  isCompleted: docData.interviews?.isCompleted ?? false,
  count: docData.interviews?.count ?? 2,
  item1: {
    name: docData.interviews?.item1.name ?? '',
    title: docData.interviews?.item1.title ?? '',
    desc: docData.interviews?.item1.desc ?? '',
    image: docData.interviews?.item1.image ?? ''
  },
  item2: { 
    name: docData.interviews?.item2.name ?? '',
    title: docData.interviews?.item2.title ?? '',
    desc: docData.interviews?.item2.desc ?? '',
    image: docData.interviews?.item2.image ?? ''
  },
  item3: { 
    name: docData.interviews?.item3.name ?? '',
    title: docData.interviews?.item3.title ?? '',
    desc: docData.interviews?.item3.desc ?? '',
    image: docData.interviews?.item3.image ?? ''
  },
  item4: { 
    name: docData.interviews?.item4.name ?? '',
    title: docData.interviews?.item4.title ?? '',
    desc: docData.interviews?.item4.desc ?? '',
    image: docData.interviews?.item4.image ?? ''
  },
  item5: { 
    name: docData.interviews?.item5.name ?? '',
    title: docData.interviews?.item5.title ?? '',
    desc: docData.interviews?.item5.desc ?? '',
    image: docData.interviews?.item5.image ?? ''
  },
  item6: { 
    name: docData.interviews?.item6.name ?? '',
    title: docData.interviews?.item6.title ?? '',
    desc: docData.interviews?.item6.desc ?? '',
    image: docData.interviews?.item6.image ?? ''
  },
});

// 2026-10-20: 新方式(rawScore差分方式)対応。version==2のデータは state/value も持つ
// (2状態: 未入力/unset・中間を含む評価済み/rated。中間はバランス型希望として計算に含める)。
// state/valueはv1データには無い(undefinedのまま)。3.recruit/2.edit/7.person.tsx が実際の
// 移行・表示ロジックを持つ。ここ(type.ts)は「読み落とさない」ための型・既定値・フォーマットのみ。
export type personAxisData = {
  left: number;
  right: number;
  state?: 'unset' | 'rated';
  value?: number;
};

export type personData = {
  isCompleted: boolean;
  version?: number;
  H_C: personAxisData;
  T_E: personAxisData;
  J_P: personAxisData;
  S_R: personAxisData;
};

export const defaultPersonData: personData = {
  isCompleted: false,
  H_C: {
    left: 0,
    right: 0
  },
  T_E: {
    left: 0,
    right: 0
  },
  J_P: {
    left: 0,
    right: 0
  },
  S_R: {
    left: 0,
    right: 0
  },
};

export const formatPerson = (docData: any): personData => {
  const axis = (a: any): personAxisData => ({
    left: a?.left ?? 0,
    right: a?.right ?? 0,
    state: a?.state,
    value: a?.value,
  });
  return {
    ...defaultPersonData,
    isCompleted: docData.person?.isCompleted ?? false,
    version: docData.person?.version,
    H_C: axis(docData.person?.H_C),
    T_E: axis(docData.person?.T_E),
    J_P: axis(docData.person?.J_P),
    S_R: axis(docData.person?.S_R),
  };
};

export type infoData = {
  isCompleted: boolean,
  companyName: string,
  companyNameKana: string,
  addressPref: string, // 本社の都道府県(searchIndex.addressPref にも入れ、アプリのリスト表示のアイコンに使う)
  address: string,
  addressKana: string,
  ownerName: string,
  ownerNameKana: string,
  establishedDate: string,
  numberOfEmployees: string,
  phoneNumber: string,
  email: string,
  homepageUrl: string,
  instagram: string,
  recruiterName: string,
  recruiterNameKana: string,
  business: {
    contents: string[],
    canConcurrent: boolean | null,
  },
  isSpecialExemption: boolean | null,
  exist36Agreement: boolean | null,
};

export const defaultInfo: infoData = {
  isCompleted: false,
  companyName: '',
  companyNameKana: '',
  addressPref: '',
  address: '',
  addressKana: '',
  ownerName: '',
  ownerNameKana: '',
  establishedDate: '',
  numberOfEmployees: '',
  phoneNumber: '',
  email: '',
  homepageUrl: '',
  instagram: '',
  recruiterName: '',
  recruiterNameKana: '',
  business: {
    contents: [],
    canConcurrent: null,
  },
  isSpecialExemption: null,
  exist36Agreement: null,
};

// 住所の先頭の都道府県(「東京都渋谷区…」→「東京都」)。決まらなければ ''。
// 先頭の郵便番号(〒104-0061)や括弧書き((本社)など)は飛ばす。都道府県を省いて市区から始まる住所
// (「京都市中京区…」)は、名前で都道府県が1つに決まる市区だけ src/cityPref.json から補う。
// functions/scripts/backfillAddressPref.cjs も同じ決め方。
const CITY_PREF_KEYS = Object.keys(cityPref)
  .filter((k) => !k.startsWith('_'))
  .sort((a, b) => b.length - a.length); // 長い名前から(大津市を津市より先に)
export const prefFromAddress = (address: unknown): string => {
  if (typeof address !== 'string') return '';
  const a = address.trim()
    .replace(/^〒?\s*\d{3}-?\d{4}\s*/, '')
    .replace(/^[（(][^）)]*[）)]\s*/, '');
  const pref = PREFECTURES.find((p) => a.startsWith(p));
  if (pref) return pref;
  const city = CITY_PREF_KEYS.find((k) => a.startsWith(k));
  return city ? (cityPref as Record<string, string>)[city] : '';
};

export const formatInfo = (docData: any): infoData => ({
  ...defaultInfo,
  isCompleted: docData.info?.isCompleted ?? false,
  companyName: docData.info?.companyName ?? "",
  companyNameKana: docData.info?.companyNameKana ?? "",
  // 未保存の会社は、住所が都道府県から始まっていればそれを初期値にする
  addressPref: docData.info?.addressPref || prefFromAddress(docData.info?.address),
  address: docData.info?.address ?? "",
  addressKana: docData.info?.addressKana ?? "",
  ownerName: docData.info?.ownerName ?? "",
  ownerNameKana: docData.info?.ownerNameKana ?? "",
  establishedDate: docData.info?.establishedDate ?? "",
  numberOfEmployees: docData.info?.numberOfEmployees ?? "",
  phoneNumber: docData.info?.phoneNumber ?? "",
  email: docData.info?.email ?? "",
  homepageUrl: docData.info?.homepageUrl ?? "",
  instagram: docData.info?.instagram ?? "",
  recruiterName: docData.info?.recruiterName ?? "",
  recruiterNameKana: docData.info?.recruiterNameKana ?? "",
  business: {
    contents: docData.info?.business?.contents ?? [],
    canConcurrent: docData.info?.business?.canConcurrent ?? null,
  },
  isSpecialExemption: docData.info?.isSpecialExemption ?? null,
  exist36Agreement: docData.info?.exist36Agreement ?? null,
});

export type shopInfoData = {
  isCompleted: boolean,
  name: string,
  nameKana: string,
  imageUrl: string,
  features: string,
  workingHoursStart: string,
  workingHoursEnd: string,
  regularHolidays: string[],
};

export const defaultShopInfo: shopInfoData = {
  isCompleted: false,
  name: '',
  nameKana: '',
  imageUrl: '',
  features: '',
  workingHoursStart: '',
  workingHoursEnd: '',
  regularHolidays: [],
};

export const formatShopInfo = (docData: any): shopInfoData => ({
  ...defaultShopInfo,
  isCompleted: docData.shopInfo?.isCompleted ?? false,
  name: docData.shopInfo?.name ?? '',
  nameKana: docData.shopInfo?.nameKana ?? '',
  imageUrl: docData.shopInfo?.imageUrl ?? '',
  features: docData.shopInfo?.features ?? '',
  workingHoursStart: docData.shopInfo?.workingHoursStart ?? '',
  workingHoursEnd: docData.shopInfo?.workingHoursEnd ?? '',
  regularHolidays: docData.shopInfo?.regularHolidays ?? [],
});

export type benefitData = {
  isCompleted: boolean,
  commutingAllowance: {
    exist: string | null,
    text: string,
  },
  overtime: {
    exist: boolean | null,
    text: string,
  },
  workingHours: {
    time1Start: string,
    time1End: string,
    time2Start: string,
    time2End: string,
    time3Start: string,
    time3End: string,
  },
  regularHolidays: string[],
  holidayPolicy: {
    exist: string | null,
    text: string,
  },
  avgMonthlyHours: string,
  paidLeave: string,
  insurance: string[],
  daysOff: string[],
  otherText: string,
  tabaco: string,
  dailyBreak: string,
  annualHolidays: string,
}

export const defaultBenefit: benefitData = {
  isCompleted: false,
  commutingAllowance: {
    exist: null,
    text: '',
  },
  overtime: {
    exist: null,
    text: '',
  },
  workingHours: {
    time1Start: '',
    time1End: '',
    time2Start: '',
    time2End: '',
    time3Start: '',
    time3End: '',
  },
  regularHolidays: [],
  holidayPolicy: {
    exist: null,
    text: "",
  },
  avgMonthlyHours: '',
  paidLeave: '',
  insurance: [],
  daysOff: [],
  otherText: "",
  tabaco: '',
  dailyBreak: "",
  annualHolidays: "",
};

export const formatBenefit = (docData: any): benefitData => ({
  ...defaultBenefit,
  isCompleted: docData.benefit?.isCompleted ?? false,
  overtime: {
    exist: docData.benefit?.overtime?.exist ?? null,
    text: docData.benefit?.overtime?.text ?? '',
  },
  commutingAllowance: {
    exist: docData.benefit?.commutingAllowance?.exist ?? null,
    text: docData.benefit?.commutingAllowance?.text ?? '',
  },
  workingHours: {
    time1Start: docData.benefit?.workingHours?.time1Start ?? '',
    time1End: docData.benefit?.workingHours?.time1End ?? '',
    time2Start: docData.benefit?.workingHours?.time2Start ?? '',
    time2End: docData.benefit?.workingHours?.time2End ?? '',
    time3Start: docData.benefit?.workingHours?.time3Start ?? '',
    time3End: docData.benefit?.workingHours?.time3End ?? '',
  },
  regularHolidays: docData.benefit?.regularHolidays ?? [],
  holidayPolicy: docData.benefit?.holidayPolicy ?? '',
  avgMonthlyHours: docData.benefit?.avgMonthlyHours ?? '',
  paidLeave: docData.benefit?.paidLeave ?? '',
  insurance: docData.benefit?.insurance ?? [],
  daysOff: docData.benefit?.daysOff ?? [],
  otherText: docData.benefit?.otherText ?? "",
  tabaco: docData.benefit?.tabaco ?? '',
  dailyBreak: docData.benefit?.dailyBreak ?? '',
  annualHolidays: docData.benefit?.annualHolidays ?? '',
});

export type employmentData20 = {
  isCompleted: boolean,
  contents: string,
  type: string,
  workSystem: string,
  salaryType: string | null,
  baseSalary: string,
  allowance: string,
  totalSalary: string,
  avgMonthlyHours: string,
  variableWork: {
    hours28Days: string,
    hours29Days: string,
    hours30Days: string,
    hours31Days: string,
    hoursYearly: string,
  },
  employmentTrial: {
    exist: boolean | null,
    text: string,
    conditions: string | null,
    trialWorkConditions: string,
  },
  contractPeriod: {
    exist: boolean | null,
    text: string,
  },
  fixedOvertime: {
    exist: boolean | null,
    price: string,
    time: string,
  },
  regularAllowance: {
    allowance1: string,
    price1: string,
    allowance2: string,
    price2: string,
    allowance3: string,
    price3: string,
  }
  incentive: string,
  paidLeave: string,
  insurance: string[],
  benefits: string,
  otherText: string,
  dailyHours: string,
}

export const defaultEmployment20: employmentData20 = {
  isCompleted: false,
  contents: '',
  type: '',
  workSystem: "",
  variableWork: {
    hours28Days: "",
    hours29Days: "",
    hours30Days: "",
    hours31Days: "",
    hoursYearly: "",
  },
  salaryType: null,
  baseSalary: '',
  allowance: '',
  totalSalary: '',
  avgMonthlyHours: '',
  employmentTrial: {
    exist: null,
    text: '',
    conditions: null,
    trialWorkConditions: "",
  },
  contractPeriod: {
    exist: null,
    text: '',
  },
  fixedOvertime: {
    exist: null,
    price: '',
    time: '',
  },
  regularAllowance: {
    allowance1: '',
    price1: '',
    allowance2: '',
    price2: '',
    allowance3: '',
    price3: '',
  },
  incentive: '',
  paidLeave: '',
  insurance: [],
  benefits: '',
  otherText: '',
  dailyHours: '',
};

export const formatEmployment20 = (docData: any): employmentData20 => ({
  ...defaultEmployment20,
  isCompleted: docData.employment20?.isCompleted ?? false,
  type: docData.employment20?.type ?? '',
  contents: docData.employment20?.contents ?? '',
  workSystem: docData.employment20?.workSystem ?? '',
  variableWork: {
    hours28Days: docData.employment20?.variableWork?.hours28Days ?? '',
    hours29Days: docData.employment20?.variableWork?.hours29Days ?? '',
    hours30Days: docData.employment20?.variableWork?.hours30Days ?? '',
    hours31Days: docData.employment20?.variableWork?.hours31Days ?? '',
    hoursYearly: docData.employment20?.variableWork?.hoursYearly ?? '',
  },
  salaryType: docData.employment20?.salaryType ?? null,
  baseSalary: docData.employment20?.baseSalary ?? '',
  allowance: docData.employment20?.allowance ?? '',
  totalSalary: docData.employment20?.totalSalary ?? '',
  avgMonthlyHours: docData.employment20?.avgMonthlyHours ?? '',
  employmentTrial: {
    exist: docData.employment20?.employmentTrial?.exist ?? null,
    text: docData.employment20?.employmentTrial?.text ?? '',
    conditions: docData.employment20?.employmentTrial?.conditions ?? null,
    trialWorkConditions: docData.employment20?.employmentTrial?.trialWorkConditions ?? "",
  },
  contractPeriod: {
    exist: docData.employment20?.contractPeriod?.exist ?? null,
    text: docData.employment20?.contractPeriod?.text ?? '',
  },
  fixedOvertime: {
    exist: docData.employment20?.fixedOvertime?.exist ?? null,
    price: docData.employment20?.fixedOvertime?.price ?? '',
    time: docData.employment20?.fixedOvertime?.time ?? '',
  },
  regularAllowance: {
    allowance1: docData.employment20?.regularAllowance?.allowance1 ?? '',
    price1: docData.employment20?.regularAllowance?.price1 ?? '',
    allowance2: docData.employment20?.regularAllowance?.allowance2 ?? '',
    price2: docData.employment20?.regularAllowance?.price2 ?? '',
    allowance3: docData.employment20?.regularAllowance?.allowance3 ?? '',
    price3: docData.employment20?.regularAllowance?.price3 ?? '',
  },
  incentive: docData.employment20?.incentive ??  '',
  paidLeave: docData.employment20?.paidLeave ?? '',
  insurance: docData.employment20?.insurance ?? [],
  benefits: docData.employment20?.benefits ?? '',
  otherText: docData.employment20?.otherText ?? '',
  dailyHours: docData.employment20?.dailyHours ?? '',
});

export type employmentData18 = {
  isCompleted: boolean,
  type: string,
  workSystem: string,
  contents: string,
  salaryType: string | null,
  baseSalary: string,
  allowance: string,
  totalSalary: string,
  avgMonthlyHours: string,
  variableWork: {
    hours28Days: string,
    hours29Days: string,
    hours30Days: string,
    hours31Days: string,
    hoursYearly: string,
  },
  employmentTrial: {
    exist: boolean | null,
    text: string,
    conditions: string | null,
    trialWorkConditions: string,
  },
  contractPeriod: {
    exist: boolean | null,
    text: string,
  },
  fixedOvertime: {
    exist: boolean | null,
    price: string,
    time: string,
  },
  regularAllowance: {
    allowance1: string,
    price1: string,
    allowance2: string,
    price2: string,
    allowance3: string,
    price3: string,
  }
  incentive: string,
  paidLeave: string,
  insurance: string[],
  benefits: string,
  otherText: string,
  dailyHours: string,
}

export const defaultEmployment18: employmentData18 = {
  isCompleted: false,
  type: '',
  workSystem: "",
  contents: "",
  salaryType: null,
  baseSalary: '',
  allowance: '',
  totalSalary: '',
  avgMonthlyHours: '',
  variableWork: {
    hours28Days: "",
    hours29Days: "",
    hours30Days: "",
    hours31Days: "",
    hoursYearly: "",
  },
  employmentTrial: {
    exist: null,
    text: '',
    conditions: null,
    trialWorkConditions: "",
  },
  contractPeriod: {
    exist: null,
    text: '',
  },
  fixedOvertime: {
    exist: null,
    price: '',
    time: '',
  },
  regularAllowance: {
    allowance1: '',
    price1: '',
    allowance2: '',
    price2: '',
    allowance3: '',
    price3: '',
  },
  incentive: '',
  paidLeave: '',
  insurance: [],
  benefits: '',
  otherText: '',
  dailyHours: '',
};

export const formatEmployment18 = (docData: any): employmentData18 => ({
  ...defaultEmployment18,
  isCompleted: docData.employment18?.isCompleted ?? false,
  type: docData.employment18?.type ?? '',
  workSystem: docData.employment18?.workSystem ?? '',
  contents: docData.employment18?.contents ?? '',
  salaryType: docData.employment18?.salaryType ?? null,
  baseSalary: docData.employment18?.baseSalary ?? '',
  allowance: docData.employment18?.allowance ?? '',
  totalSalary: docData.employment18?.totalSalary ?? '',
  avgMonthlyHours: docData.employment18?.avgMonthlyHours ?? '',
  variableWork: {
    hours28Days: docData.employment18?.variableWork?.hours28Days ?? '',
    hours29Days: docData.employment18?.variableWork?.hours29Days ?? '',
    hours30Days: docData.employment18?.variableWork?.hours30Days ?? '',
    hours31Days: docData.employment18?.variableWork?.hours31Days ?? '',
    hoursYearly: docData.employment18?.variableWork?.hoursYearly ?? '',
  },
  employmentTrial: {
    exist: docData.employment18?.employmentTrial?.exist ?? null,
    text: docData.employment18?.employmentTrial?.text ?? '',
    conditions: docData.employment18?.employmentTrial?.conditions ?? null,
    trialWorkConditions: docData.employment18?.employmentTrial?.trialWorkConditions ?? "",
  },
  contractPeriod: {
    exist: docData.employment18?.contractPeriod?.exist ?? null,
    text: docData.employment18?.contractPeriod?.text ?? '',
  },
  fixedOvertime: {
    exist: docData.employment18?.fixedOvertime?.exist ?? null,
    price: docData.employment18?.fixedOvertime?.price ?? '',
    time: docData.employment18?.fixedOvertime?.time ?? '',
  },
  regularAllowance: {
    allowance1: docData.employment18?.regularAllowance?.allowance1 ?? '',
    price1: docData.employment18?.regularAllowance?.price1 ?? '',
    allowance2: docData.employment18?.regularAllowance?.allowance2 ?? '',
    price2: docData.employment18?.regularAllowance?.price2 ?? '',
    allowance3: docData.employment18?.regularAllowance?.allowance3 ?? '',
    price3: docData.employment18?.regularAllowance?.price3 ?? '',
  },
  incentive: docData.employment18?.incentive ??  '',
  paidLeave: docData.employment18?.paidLeave ?? '',
  insurance: docData.employment18?.insurance ?? [],
  benefits: docData.employment18?.benefits ?? '',
  otherText: docData.employment18?.otherText ?? '',
  dailyHours: docData.employment18?.dailyHours ?? '',
});

export type employmentData17 = {
  isCompleted: boolean,
  type: string,
  workSystem: string,
  contents: string,
  salaryType: string | null,
  baseSalary: string,
  allowance: string,
  totalSalary: string,
  avgMonthlyHours: string,
  variableWork: {
    hours28Days: string,
    hours29Days: string,
    hours30Days: string,
    hours31Days: string,
    hoursYearly: string,
  },
  employmentTrial: {
    exist: boolean | null,
    text: string,
    conditions: string | null,
    trialWorkConditions: string,
  },
  contractPeriod: {
    exist: boolean | null,
    text: string,
  },
  fixedOvertime: {
    exist: boolean | null,
    price: string,
    time: string,
  },
  regularAllowance: {
    allowance1: string,
    price1: string,
    allowance2: string,
    price2: string,
    allowance3: string,
    price3: string,
  }
  incentive: string,
  paidLeave: string,
  insurance: string[],
  benefits: string,
  otherText: string,
  dailyHours: string,
}

export const defaultEmployment17: employmentData17 = {
  isCompleted: false,
  type: '',
  workSystem: "",
  contents: "",
  salaryType: null,
  baseSalary: '',
  allowance: '',
  totalSalary: '',
  avgMonthlyHours: '',
  variableWork: {
    hours28Days: "",
    hours29Days: "",
    hours30Days: "",
    hours31Days: "",
    hoursYearly: "",
  },
  employmentTrial: {
    exist: null,
    text: '',
    conditions: null,
    trialWorkConditions: "",
  },
  contractPeriod: {
    exist: null,
    text: '',
  },
  fixedOvertime: {
    exist: null,
    price: '',
    time: '',
  },
  regularAllowance: {
    allowance1: '',
    price1: '',
    allowance2: '',
    price2: '',
    allowance3: '',
    price3: '',
  },
  incentive: '',
  paidLeave: '',
  insurance: [],
  benefits: '',
  otherText: '',
  dailyHours: '',
};

export const formatEmployment17 = (docData: any): employmentData17 => ({
  ...defaultEmployment17,
  isCompleted: docData.employment17?.isCompleted ?? false,
  contents: docData.employment17?.contents ?? '',
  type: docData.employment17?.type ?? '',
  workSystem: docData.employment17?.workSystem ?? '',
  salaryType: docData.employment17?.salaryType ?? null,
  baseSalary: docData.employment17?.baseSalary ?? '',
  allowance: docData.employment17?.allowance ?? '',
  totalSalary: docData.employment17?.totalSalary ?? '',
  avgMonthlyHours: docData.employment17?.avgMonthlyHours ?? '',
  variableWork: {
    hours28Days: docData.employment17?.variableWork?.hours28Days ?? '',
    hours29Days: docData.employment17?.variableWork?.hours29Days ?? '',
    hours30Days: docData.employment17?.variableWork?.hours30Days ?? '',
    hours31Days: docData.employment17?.variableWork?.hours31Days ?? '',
    hoursYearly: docData.employment17?.variableWork?.hoursYearly ?? '',
  },
  employmentTrial: {
    exist: docData.employment17?.employmentTrial?.exist ?? null,
    text: docData.employment17?.employmentTrial?.text ?? '',
    conditions: docData.employment17?.employmentTrial?.conditions ?? null,
    trialWorkConditions: docData.employment17?.employmentTrial?.trialWorkConditions ?? "",
  },
  contractPeriod: {
    exist: docData.employment17?.contractPeriod?.exist ?? null,
    text: docData.employment17?.contractPeriod?.text ?? '',
  },
  fixedOvertime: {
    exist: docData.employment17?.fixedOvertime?.exist ?? null,
    price: docData.employment17?.fixedOvertime?.price ?? '',
    time: docData.employment17?.fixedOvertime?.time ?? '',
  },
  regularAllowance: {
    allowance1: docData.employment17?.regularAllowance?.allowance1 ?? '',
    price1: docData.employment17?.regularAllowance?.price1 ?? '',
    allowance2: docData.employment17?.regularAllowance?.allowance2 ?? '',
    price2: docData.employment17?.regularAllowance?.price2 ?? '',
    allowance3: docData.employment17?.regularAllowance?.allowance3 ?? '',
    price3: docData.employment17?.regularAllowance?.price3 ?? '',
  },
  incentive: docData.employment17?.incentive ??  '',
  paidLeave: docData.employment17?.paidLeave ?? '',
  insurance: docData.employment17?.insurance ?? [],
  benefits: docData.employment17?.benefits ?? '',
  otherText: docData.employment17?.otherText ?? '',
  dailyHours: docData.employment17?.dailyHours ?? '',
});

// ヘア、メイク、アイ、ネイル、ブライダル、エステ

export type applicationInfoData = {
  isCompleted: boolean,
  recruitsBarber: string,
  recruitsBeauty: string,
  recruitsMake: string,
  recruitsEye: string,
  recruitsNeil: string,
  recruitsBridal: string,
  recruitsAesthetic: string,
  businessDescription: string[],
  applicationDocuments: string[],
  submissionMethod: string,
  storeTour: string,
  selectionDate: string,
  selectionMethod: string,
  selectionRound1: string,
  selectionRound2: string,
  selectionRound3: string,
  selectionOtherDetails: string
}

export const defaultApplicationInfo: applicationInfoData = {
  isCompleted: false,
  recruitsBarber: '',
  recruitsBeauty: '',
  recruitsMake: '',
  recruitsEye: '',
  recruitsNeil: '',
  recruitsBridal: '',
  recruitsAesthetic: '',
  businessDescription: [],
  applicationDocuments: [],
  submissionMethod: '',
  storeTour: '',
  selectionDate: '',
  selectionMethod: '',
  selectionRound1: '',
  selectionRound2: '',
  selectionRound3: '',
  selectionOtherDetails: ''
};

export const formatApplicationInfo = (docData: any): applicationInfoData => ({
  ...defaultApplicationInfo,
  isCompleted: docData.applicationInfo?.isCompleted ?? false,
  recruitsBarber: docData.applicationInfo?.recruitsBarber ?? '',
  recruitsBeauty: docData.applicationInfo?.recruitsBeauty ?? '',
  recruitsMake: docData.applicationInfo?.recruitsMake ?? '',
  recruitsEye: docData.applicationInfo?.recruitsEye ?? '',
  recruitsNeil: docData.applicationInfo?.recruitsNeil ?? '',
  recruitsBridal: docData.applicationInfo?.recruitsBridal ?? '',
  recruitsAesthetic: docData.applicationInfo?.recruitsAesthetic ?? '',
  businessDescription: docData.applicationInfo?.businessDescription ?? [],
  applicationDocuments: docData.applicationInfo?.applicationDocuments ?? [],
  submissionMethod: docData.applicationInfo?.submissionMethod ?? '',
  storeTour: docData.applicationInfo?.storeTour ?? '',
  selectionDate: docData.applicationInfo?.selectionDate ?? '',
  selectionMethod: docData.applicationInfo?.selectionMethod ?? '',
  selectionRound1: docData.applicationInfo?.selectionRound1 ?? '',
  selectionRound2: docData.applicationInfo?.selectionRound2 ?? '',
  selectionRound3: docData.applicationInfo?.selectionRound3 ?? '',
  selectionOtherDetails: docData.applicationInfo?.selectionOtherDetails ?? ''
});

export type pamphletData = {
  isCompleted: boolean,
  id: string,
  // パンフレット有無の選択状態(true:有り / false:無し / null:未選択)。
  // idが空文字の場合(無し・未選択のどちらでもあり得る)を区別するために必要。
  exist: boolean | null,
  // 最後に保存した時刻(ミリ秒)。PDFは毎回同じ名前(pamphlet/{id})で上書きするため、
  // URLの末尾に付けて、差し替えたときに古いPDFが表示されないようにする(pamphletUrl)。
  version: number,
}

export const defaultPamphlet: pamphletData = {
  isCompleted: false,
  id: '',
  exist: null,
  version: 0,
};

const pamphletVersionOf = (time: any): number => {
  if (time?.toMillis) return time.toMillis();
  if (typeof time?.seconds === 'number') return time.seconds * 1000;
  if (time instanceof Date) return time.getTime();
  return 0;
};

export const formatPamphlet = (docData: any): pamphletData => ({
  ...defaultPamphlet,
  isCompleted: docData.pamphlet?.isCompleted ?? false,
  id: docData.pamphlet?.id ?? "",
  // exist未保存の既存データとの互換: idがあれば「有り」、無ければ「未選択」とみなす。
  exist: docData.pamphlet?.exist ?? (docData.pamphlet?.id ? true : null),
  version: pamphletVersionOf(docData.pamphlet?.time),
});

// パンフレット(PDF)のURL。保存した時刻を末尾に付け、差し替えたらURLが変わるようにする。
export const pamphletUrl = (id: string, version?: number): string =>
  `https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/pamphlet%2F${id}?alt=media${version ? `&v=${version}` : ''}`;

export type promotionData = {
  isCompleted: boolean,
  companyPr: string,
}

export const defaultPromotion: promotionData = {
  isCompleted: false,
  companyPr: '',
};

export const formatPromotion = (docData: any): promotionData => ({
  ...defaultPromotion,
  isCompleted: docData.promotion?.isCompleted ?? false,
  companyPr: docData.promotion?.companyPr ?? '',
});

export type targetData = {
  isCompleted: boolean,
  target: string[],
}

export const defaultTarget: targetData = {
  isCompleted: false,
  target: [ "専門(20歳卒)" ],
};

export const formatTarget = (docData: any): targetData => ({
  ...defaultTarget,
  isCompleted: docData.target?.isCompleted ?? false,
  target: docData.target?.target ?? [ "専門(20歳卒)" ],
});

export type hashTagsData = {
  isCompleted: boolean,
  tags1: string[],
  tags2: string[],
  tags3: string[],
}

export const defaultHashTagsData: hashTagsData = {
  isCompleted: false,
  tags1: [],
  tags2: [],
  tags3: [],
};

export const formatHashTags = (docData: any): hashTagsData => ({
  ...defaultHashTagsData,
  isCompleted: docData.hashTag?.isCompleted ?? false,
  tags1: docData.hashTag?.tags1 ?? [],
  tags2: docData.hashTag?.tags2 ?? [],
  tags3: docData.hashTag?.tags3 ?? [],
});

export type docData = {
  isCompleted: boolean,
  visit: boolean,
  document: boolean,
  resume: boolean,
  question: boolean,
  coordinate: boolean,
  questionCount: number,
  question1: string,
  question2: string,
  question3: string,
  otherDocument: boolean,
  otherDocumentCount: number,
  otherDocument1: string,
  otherDocument2: string,
  otherDocument3: string,
}

export const defaultDocumentData: docData = {
  isCompleted: false,
  visit: false,
  document: false,
  resume: false,
  question: false,
  coordinate: false,
  questionCount: 0,
  question1: '',
  question2: '',
  question3: '',
  otherDocument: false,
  otherDocumentCount: 0,
  otherDocument1: '',
  otherDocument2: '',
  otherDocument3: '',
};

export const formatDocument = (docData: any): docData => ({
  ...defaultDocumentData,
  isCompleted: docData.document?.isCompleted ?? false,
  visit: docData.document?.visit ?? false,
  document: docData.document?.document ?? false,
  resume: docData.document?.resume ?? false,
  question: docData.document?.question ?? false,
  coordinate: docData.document?.coordinate ?? false,
  questionCount: docData.document?.questionCount ?? 0,
  question1: docData.document?.question1 ?? '',
  question2: docData.document?.question2 ?? '',
  question3: docData.document?.question3 ?? '',
  otherDocument: docData.document?.otherDocument ?? false,
  otherDocumentCount: docData.document?.otherDocumentCount ?? 0,
  otherDocument1: docData.document?.otherDocument1 ?? '',
  otherDocument2: docData.document?.otherDocument2 ?? '',
  otherDocument3: docData.document?.otherDocument3 ?? '',
});

export type sendingData = {
  "2027_sending": string[],
}

export const defaultSending: sendingData = {
  "2027_sending": [],
};

export type storeData = {
  id?: string;

  address: string;
  companyId: string;
  image: string;
  last_time: Date;
  name: string;
  number: number;

  pentagonHash: string[];
  pentagonStyle1: number;
  pentagonStyle2: number;
  pentagonStyle3: number;
  pentagonStyle4: number;
  pentagonStyle5: number;
  pentagonStyle6: number;
  pentagonStyleInput: string;

  pentagonTreatment1: number;
  pentagonTreatment2: number;
  pentagonTreatment3: number;
  pentagonTreatment4: number;
  pentagonTreatment5: number;
  pentagonTreatment6: number;

  postCode: string;
  recruitId: string;
  region: boolean;

  station1Name: string;
  station1Time: string;
  station2Name: string;
  station2Time: string;
  station3Name: string;
  station3Time: string;
  stationCount: number;
  stationTags: string[];

  status: boolean;
  status_pentagon: boolean;
  status_place: boolean;
  status_type: boolean;

  storeAddress: string;
  storeCount: number;
  storePostCode: string;
  storeStation1Name: string;
  storeStation1Time: string;
  storeStation2Name: string;
  storeStation2Time: string;
  storeStation3Name: string;
  storeStation3Time: string;

  strengths: boolean;
  time: Date;
  treatment: boolean;
  type: string;
};

export const defaultStoreData: storeData = {
  id: "",

  address: "",
  companyId: "",
  image: "",
  last_time: new Date(),
  name: "",
  number: 0,

  pentagonHash: [],
  pentagonStyle1: 1,
  pentagonStyle2: 1,
  pentagonStyle3: 1,
  pentagonStyle4: 1,
  pentagonStyle5: 1,
  pentagonStyle6: 1,
  pentagonStyleInput: "",

  pentagonTreatment1: 1,
  pentagonTreatment2: 1,
  pentagonTreatment3: 1,
  pentagonTreatment4: 1,
  pentagonTreatment5: 1,
  pentagonTreatment6: 1,

  postCode: "",
  recruitId: "",
  region: false,

  station1Name: "",
  station1Time: "",
  station2Name: "",
  station2Time: "",
  station3Name: "",
  station3Time: "",
  stationCount: 0,
  stationTags: [],

  status: false,
  status_pentagon: false,
  status_place: false,
  status_type: false,

  storeAddress: "",
  storeCount: 0,
  storePostCode: "",
  storeStation1Name: "",
  storeStation1Time: "",
  storeStation2Name: "",
  storeStation2Time: "",
  storeStation3Name: "",
  storeStation3Time: "",

  strengths: false,
  time: new Date(),
  treatment: false,
  type: "",
};

export const formatStore = (docData: any): storeData => ({
  ...defaultStoreData,
  address: docData.address ?? "",
  companyId: docData.companyId ?? "",
  image: docData.image ?? "",
  last_time: docData.last_time ?? new Date(),
  name: docData.name ?? "",
  number: docData.number ?? 0,

  pentagonHash: docData.pentagonHash ?? [],
  pentagonStyle1: docData.pentagonStyle1 ?? 0,
  pentagonStyle2: docData.pentagonStyle2 ?? 0,
  pentagonStyle3: docData.pentagonStyle3 ?? 0,
  pentagonStyle4: docData.pentagonStyle4 ?? 0,
  pentagonStyle5: docData.pentagonStyle5 ?? 0,
  pentagonStyle6: docData.pentagonStyle6 ?? 0,
  pentagonStyleInput: docData.pentagonStyleInput ?? "",

  pentagonTreatment1: docData.pentagonTreatment1 ?? 0,
  pentagonTreatment2: docData.pentagonTreatment2 ?? 0,
  pentagonTreatment3: docData.pentagonTreatment3 ?? 0,
  pentagonTreatment4: docData.pentagonTreatment4 ?? 0,
  pentagonTreatment5: docData.pentagonTreatment5 ?? 0,
  pentagonTreatment6: docData.pentagonTreatment6 ?? 0,

  postCode: docData.postCode ?? "",
  recruitId: docData.recruitId ?? "",
  region: docData.region ?? false,

  station1Name: docData.station1Name ?? "",
  station1Time: docData.station1Time ?? "",
  station2Name: docData.station2Name ?? "",
  station2Time: docData.station2Time ?? "",
  station3Name: docData.station3Name ?? "",
  station3Time: docData.station3Time ?? "",
  stationCount: docData.stationCount ?? 0,
  stationTags: docData.stationTags ?? [],

  status: docData.status ?? false,
  status_pentagon: docData.status_pentagon ?? false,
  status_place: docData.status_place ?? false,
  status_type: docData.status_type ?? false,

  storeAddress: docData.storeAddress ?? "",
  storeCount: docData.storeCount ?? 0,
  storePostCode: docData.storePostCode ?? "",
  storeStation1Name: docData.storeStation1Name ?? "",
  storeStation1Time: docData.storeStation1Time ?? "",
  storeStation2Name: docData.storeStation2Name ?? "",
  storeStation2Time: docData.storeStation2Time ?? "",
  storeStation3Name: docData.storeStation3Name ?? "",
  storeStation3Time: docData.storeStation3Time ?? "",

  strengths: docData.strengths ?? false,
  time: docData.time ?? new Date(),
  treatment: docData.treatment ?? false,
  type: docData.type ?? "",
});

export const prfWage: Record<string, number> = {
  "北海道": 1131,
  "青森県": 1090,
  "岩手県": 1090,
  "宮城県": 1098,
  "秋田県": 1090,
  "山形県": 1092,
  "福島県": 1094,
  "茨城県": 1136,
  "栃木県": 1125,
  "群馬県": 1120,
  "埼玉県": 1196,
  "千葉県": 1195,
  "東京都": 1280,
  "神奈川県": 1279,
  "新潟県": 1108,
  "富山県": 1119,
  "石川県": 1113,
  "福井県": 1112,
  "山梨県": 1113,
  "長野県": 1117,
  "岐阜県": 1121,
  "静岡県": 1154,
  "愛知県": 1195,
  "三重県": 1143,
  "滋賀県": 1136,
  "京都府": 1180,
  "大阪府": 1231,
  "兵庫県": 1172,
  "奈良県": 1107,
  "和歌山県": 1101,
  "鳥取県": 1090,
  "島根県": 1092,
  "岡山県": 1104,
  "広島県": 1141,
  "山口県": 1101,
  "徳島県": 1103,
  "香川県": 1092,
  "愛媛県": 1093,
  "高知県": 1086,
  "福岡県": 1114,
  "佐賀県": 1095,
  "長崎県": 1087,
  "熊本県": 1092,
  "大分県": 1096,
  "宮崎県": 1085,
  "鹿児島県": 1090,
  "沖縄県": 1086,
};

export const defaultInitialDataMap = {
  companyId: "",
  jobPostingsStatus: 3,
  recruitStatus: 3,
  time: new Date(),

  summary: defaultSummaryData,
  point: defaultPointData,
  number: defaultNumberData,
  strong: defaultStrongData,
  interviews: defaultInterviewsData,
  person: defaultPersonData,
  info: defaultInfo,
  benefit: defaultBenefit,
  employment20: defaultEmployment20,
  employment18: defaultEmployment18,
  employment17: defaultEmployment17,
  applicationInfo: defaultApplicationInfo,
  pamphlet: defaultPamphlet,
  target: defaultTarget,
  hashTag: defaultHashTagsData,
  document: defaultDocumentData,
  store: { isCompleted: false },
  ...defaultSending,
};

export const PREFECTURES = [
  "北海道",
  "青森県",
  "岩手県",
  "宮城県",
  "秋田県",
  "山形県",
  "福島県",
  "茨城県",
  "栃木県",
  "群馬県",
  "埼玉県",
  "千葉県",
  "東京都",
  "神奈川県",
  "山梨県",
  "長野県",
  "新潟県",
  "富山県",
  "石川県",
  "福井県",
  "岐阜県",
  "静岡県",
  "愛知県",
  "三重県",
  "滋賀県",
  "京都府",
  "大阪府",
  "兵庫県",
  "奈良県",
  "和歌山県",
  "鳥取県",
  "島根県",
  "岡山県",
  "広島県",
  "山口県",
  "徳島県",
  "香川県",
  "愛媛県",
  "高知県",
  "福岡県",
  "佐賀県",
  "長崎県",
  "熊本県",
  "大分県",
  "宮崎県",
  "鹿児島県",
  "沖縄県",
];

export const SALARY_OPTIONS = [
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
];

export const SALON_TYPE_OPTIONS = [
  "有名サロン",
  "トレンドサロン",
  "おしゃれサロン",
  "ビューティーサロン",
  "オールラウンドサロン",
  "密着サロン",
  "愛されサロン",
  "こだわりサロン",
];

export const treatmentTags = [
  "カットが得意",
  "カラーが得意",
  "パーマが得意",
  "縮毛矯正が得意",
  "ヘアメイクが得意",
];

export const styleTags = [
  "かっこいい施術多め",
  "ナチュラルな施術多め",
  "トレンド感のある施術多め",
  "クリエイティブな施術多め",
  "エレガントな施術多め",
];

export const educationTags = [
  "デビューまで2年以内",
  "SNS研修あり",
  "自社アカデミーあり",
  "動画研修制度あり",
  "セミナー参加費補助",
  "ウィッグ代補助",
  "奨学金返済サポートあり",
  "営業中の練習OK",
  "資格取得支援",
  "社内コンテストあり",
  "複数の教育体制から選択可",
  "複数のキャリアプランを選択可",
  "独立・開業支援あり",
  "海外研修あり",
];

export const salaryTags = [
  "社会保険完備",
  "寮・社宅あり",
  "ボーナス支給実績あり",
  "住宅手当あり",
  "車・バイク出勤可",
  "育児休暇あり",
  "国内就労ビザ取得支援あり（留学生向け）",
];

export const workTags = [
  "年間休日120日以上",
  "残業月20時間以内",
  "有給休暇消化率90%以上",
  "時短勤務可",
  "完全週休2日制",
  "20時までに退勤可能",
  "配属店舗の選択可",
];

export type ValidationError = {
  message: string,
  fieldId: string,
} | null;

export type CompanyData = {
  member_id: string;
  id: string;
  name: string;
  logo: boolean;
  owner: string[];
  invite: string[];
  judgeUids: string[];
  judgeInviteEmails: string[];
  judgeInvites: {
    email: string;
    name: string;
    uid: string;
    status: 'invited' | 'claimed';
    createdAt: any;
  }[];
  contract: boolean;
  time: Date;
  notification: {
    mail: string;
    lineId: string;
    linePicture: string;
    lineName: string;
  }
  progress: {
    plan: boolean,
    icon: boolean,
    jobPostings: boolean,
    sending: boolean,
    complete: boolean,
  }
  // 審査員ログイン用。通常の会社オーナーは常に role:'owner'。
  // 審査員セッションは owner配列とは別に companies.judgeUids 経由で解決され、role:'judge' になる。
  role: 'owner' | 'judge';
  judgeName: string;
};

// デフォルト値
export const defaultCompanyData: CompanyData = {
  member_id: "",
  id:  "",
  name: "",
  logo: false,
  owner: [],
  invite: [],
  judgeUids: [],
  judgeInviteEmails: [],
  judgeInvites: [],
  contract: false,
  time: new Date(),
  notification: {
    mail: "",
    lineId: "",
    linePicture: "",
    lineName: "",
  },
  progress: {
    plan: false,
    icon: false,
    jobPostings: false,
    sending: false,
    complete: false,
  },
  role: 'owner',
  judgeName: '',
};

// Firestoreのドキュメントデータから変換
export const formatCompanyData = (docData: any): CompanyData => ({
  ...defaultCompanyData,
  member_id: docData.member_id ?? '',
  id: docData.id ?? '',
  name: docData.name ?? '',
  logo: docData.logo ?? false,
  owner: docData.owner ?? [],
  invite: docData.invite ?? [],
  judgeUids: docData.judgeUids ?? [],
  judgeInviteEmails: docData.judgeInviteEmails ?? [],
  judgeInvites: docData.judgeInvites ?? [],
  time: docData.time ?? new Date(),
  contract: docData.contract ?? false,
  notification: {
    mail: docData.notification?.mail ?? "",
    lineId: docData.notification?.lineId ?? "",
    linePicture: docData.notification?.linePicture ?? "",
    lineName: docData.notification?.lineName ?? "",
  },
  progress: {
    plan: docData.progress?.plan ?? false,
    icon: docData.progress?.icon ?? false,
    jobPostings: docData.progress?.jobPostings ?? false,
    sending: docData.progress?.sending ?? false,
    complete: docData.progress?.complete ?? false,
  },
  role: docData.role ?? 'owner',
  judgeName: docData.judgeName ?? '',
});

export interface RecruitList {
  id: string;
  selection: number;
  selectionCount: number;
  selectionText1: string;
  selectionText2: string;
  selectionText3: string;
  selectionText4: string;
  selectionText5: string;
  selectionText6: string;
  selectionText7: string;
  selectionText8: string;
  resume: boolean;
  coordinate: boolean;
  question: boolean;
  questionCount: number;
  question01: string;
  question02: string;
  question03: string;
  otherDocument: boolean;
  otherDocumentCount: number;
  otherDocument01: string;
  otherDocument02: string;
  otherDocument03: string;
}

// export interface ApplicantList {
//   id: string;
//   examination: number;
//   recruitId: string;
//   time: string;
//   name: string;
//   nameHurigana: string;
//   birthdayYears: string;
//   birthdayMonth: string;
//   birthdayDays: string;
//   age: string;
//   sex: string;
//   bloodType: string;
//   addressHurigana: string;
//   postCode: string;
//   address: string;
//   phoneNumber: string;
//   mailAddress: string;
//   history1: string;
//   historyYears1: string;
//   historyMonth1: string;
//   history2: string;
//   historyYears2: string;
//   historyMonth2: string;
//   history3: string;
//   historyYears3: string;
//   historyMonth3: string;
//   history4: string;
//   historyYears4: string;
//   historyMonth4: string;
//   history5: string;
//   historyYears5: string;
//   historyMonth5: string;
//   history6: string;
//   historyYears6: string;
//   historyMonth6: string;
//   award1: string;
//   awardYears1: string;
//   awardMonth1: string;
//   award2: string;
//   awardYears2: string;
//   awardMonth2: string;
//   award3: string;
//   awardYears3: string;
//   awardMonth3: string;
//   instagram: string;
//   instagramFollower: string;
//   tiktok: string;
//   tiktokFollower: string;
//   twitter: string;
//   twitterFollower: string;
//   motivation: string;
//   prText: string;
//   coordinate1Title: string;
//   coordinate1Point: string;
//   coordinate2Title: string;
//   coordinate2Point: string;
//   coordinate3Title: string;
//   coordinate3Point: string;
//   question01Text: string;
//   question02Text: string;
//   question03Text: string;
// }

export const defaultRecruit: RecruitList = {
  id: "",
  selection: 1,
  selectionCount: 5,
  selectionText1: "",
  selectionText2: "",
  selectionText3: "",
  selectionText4: "",
  selectionText5: "",
  selectionText6: "",
  selectionText7: "",
  selectionText8: "",
  resume: false,
  coordinate: false,
  question: false,
  questionCount: 0,
  question01: '',
  question02: '',
  question03: '',
  otherDocument: false,
  otherDocumentCount: 0,
  otherDocument01: '',
  otherDocument02: '',
  otherDocument03: '',
};


export const schoolList: any[] = [
  [ "VfebuLLVlIKQn7SDLaPi", "旭川理容美容専門学校", "北海道地方", "北海道", "北海道旭川市4条通12丁目655", ],
  [ "c87VPc8ARZ1E0pSBhnlA", "北見美容専門学校", "北海道地方", "北海道", "北海道北見市花月町17−15", ],
  [ "jzUhkTvs0ROAgaYloreE", "釧路理容美容専門学校", "北海道地方", "北海道", "北海道釧路市城山1丁目6−10", ],
  [ "BdvuP42vpg0Ppose979M", "札幌ビューティックアカデミー", "北海道地方", "北海道", "北海道札幌市中央区北6条西10丁目11−1", ],
  [ "hWIzPALhrxEkEXgMjt3z", "札幌ベルエポック美容専門学校", "北海道地方", "北海道","北海道札幌市中央区北1条西9丁目3−4", ],
  [ "jKm8xuwcsiFSljYGCUvU", "函館理容美容専門学校", "北海道地方", "北海道", "北海道函館市中島町31−25", ],
  [ "MofURROGF27Lq2p6sSw1", "北海道美容専門学校",  "北海道地方", "北海道", "北海道札幌市中央区南3条西10丁目1004−3", ],
  [ "Y3AidQXu73G7txj8PEL2", "北海道理容美容専門学校", "北海道地方", "北海道", "北海道札幌市中央区南2条西20丁目1−1", ],
  [ "3ZDstghMiT21lb3Vw6e2", "青森県ビューティー&メディカル専門学校", "東北地方", "青森県", "青森県青森市久須志1丁目45−2", ],
  [ "ZriYgbF6TZ41urRdfnB6", "青森県ヘアアーチスト専門学校", "東北地方", "青森県", "青森県弘前市表町6−4", ],
  [ "kXMuwn9Mu7u8486FhByx", "八戸理容美容専門学校", "東北地方", "青森県", "青森県八戸市小中野3丁目5−1", ],
  [ "Na1bKvJvqTITwzkM1WDN", "岩手理容美容専門学校", "東北地方", "岩手県", "岩手県花巻市若葉町2丁目14−39 14番39号", ],
  [ "MemszPsG5zDbV84NGHb7", "盛岡ヘアメイク専門学校", "東北地方", "岩手県", "岩手県盛岡市盛岡駅前北通12−31", ],
  [ "0DhIG7oWH4oaxdG3lukL", "東北ヘア－モード学院", "東北地方", "岩手県", "岩手県一関市旭町5−14", ],
  [ "mTlwQJAtO6RQyFSk4RLV", "仙台理容美容専門学校", "東北地方", "宮城県", "宮城県仙台市太白区富沢南2丁目18−1", ],
  [ "TDgV6labPoDRybBCaNxU", "東北芸術高等専修学校", "東北地方", "宮城県", "宮城県仙台市宮城野区榴岡4丁目6−20", ],
  [ "9MaS5ffvRmNqcPXMIykl", "仙台ヘアメイク専門学校", "東北地方", "宮城県", "宮城県仙台市青葉区中央3丁目4−8", ],
  [ "RREXrEtZg9l1Uq2wERPc", "SENDAI中央理容美容専門学校", "東北地方", "宮城県", "宮城県仙台市宮城野区新田東2丁目11−4", ],
  [ "BvUO0uhDuZpXgk9vWOZZ", "仙台ビューティーアート専門学校", "東北地方", "宮城県", "宮城県仙台市宮城野区榴岡3丁目8−25", ],
  [ "VNRr0kUxBq5jfekmGkHs", "秋田県理容美容専門学校", "東北地方", "秋田県", "秋田県秋田市千秋明徳町4−53", ],
  [ "e2DleRJ4AuGWo0xcRetv", "秋田ヘアビューティカレッジ", "東北地方", "秋田県", "秋田県秋田市中通6丁目18−13", ],
  [ "8VYvgL6kjAYzW8I3pDSB", "山形美容専門学校", "東北地方", "山形県", "山形県山形市薬師町1丁目4−25", ],
  [ "D95fBLqqMQjBEBjskxOh", "山形理容学校", "東北地方", "山形県", "山形県山形市相生町8−52", ],
  [ "FbpzLDkBue3AYWqsW1Q0", "会津美容高等専修学校AIZUビューティーカレッジ", "東北地方", "福島県", "福島県会津若松市中央1丁目5−23", ],
  [ "sI2DhkAxlX6IR0LpTZPE", "iwakiヘアメイクアカデミー", "東北地方", "福島県", "福島県いわき市平谷川瀬明治町11−96−1", ],
  [ "3YTlV2kxCKne5pjmVm52", "郡山理容学校", "東北地方", "福島県", "福島県郡山市富久山町久保田金堀田53−2", ],
  [ "ddsrIzN8aICLALM2lMfh", "郡山ヘアメイクカレッジ", "東北地方", "福島県", "福島県郡山市笹川3丁目53−1", ],
  [ "aMOUuPUFXUhQHx0bz83o", "国際ビューティー＆フード大学校", "東北地方", "福島県", "福島県郡山市方八町2丁目4−21", ],
  [ "q1V2KWDwuYFKBWwiaBeB", "茨城理容美容専門学校", "関東地方", "茨城県", "茨城県石岡市府中1丁目2−13", ],
  [ "7Pc5DYytT8PZ0y1OGdq9", "EIKA美容専門学校", "関東地方", "茨城県", "茨城県古河市旭町2丁目11−6", ],
  [ "yLwrhytwPGiyYY0OXfoK", "水戸ビューティーカレッジ", "関東地方", "茨城県", "茨城県水戸市浜田2－14－14", ],
  [ "A8YIMPoYT2WE4RrQrdBs", "水戸美容専門学校", "関東地方", "茨城県", "茨城県水戸市新荘2丁目14−3", ],
  [ "DDXrF6fHdPIz2Fg9HuwR", "足利デザイン・ビューティ専門学校", "関東地方", "栃木県", "栃木県足利市田中町914", ],
  [ "3ATZ6MDyoU3kDxcicadG", "栃木県美容専門学校", "関東地方", "栃木県", "栃木県宇都宮市宿郷2丁目10−11", ],
  [ "UuET1ZfWHR7bUpQ64Y27", "国際テクニカル美容専門学校", "関東地方", "栃木県", "栃木県宇都宮市大通り4丁目1−19", ],
  [ "xTqyKDPmbcGR5j8kzOpP", "国際テクニカル理容美容専門学校", "関東地方", "栃木県", "栃木県宇都宮市大通り4丁目1−19", ],
  [ "tiGHP8QE07PslpKRgsci", "伊勢崎美容専門学校", "関東地方", "群馬県", "群馬県伊勢崎市三光町9-19 ", ],
  [ "Gx1Q3DUMCDOYySu9OEcV", "群馬県美容専門学校", "関東地方", "群馬県", "群馬県前橋市石関町136−1", ],
  [ "JG9H4eB0gJ7sSEbtiChU", "高崎ビューティモード専門学校", "関東地方", "群馬県", "群馬県高崎市栄町13−1", ],
  [ "E0gUdLXYpDTsVNd15f5R", "グルノーブル美容専門学校", "関東地方", "埼玉県", "埼玉県児玉郡神川町新里1368−13", ],
  [ "2sx4vihNwgiTz9nzVme0", "専門学校 トータルビューティカレッジ川越", "関東地方", "埼玉県", "埼玉県川越市新宿町1丁目20−9", ],
  [ "MxSQs9bwBch4Ytx055mZ", "大宮理容美容専門学校", "関東地方", "埼玉県", "埼玉県さいたま市大宮区桜木町4丁目92", ],
  [ "x6SpRReATnc0iXf9bSfC", "大宮ビューティー＆ブライダル専門学校", "関東地方", "埼玉県", "埼玉県さいたま市大宮区桜木町1丁目389−3", ],
  [ "CoU0be0nh5mfNa9M90U0", "埼玉東萌美容専門学校", "関東地方", "埼玉県", "埼玉県越谷市七左町1丁目337−3", ],
  [ "JRisP4ReWHRadroYIznI", "ミス・パリ・ビューティ専門学校 大宮校", "関東地方", "埼玉県", "埼玉県さいたま市大宮区高鼻町1丁目46", ],
  [ "tjmxE2PTfRYxFow9eG4O", "東京ベイカレッジ", "関東地方", "千葉県", "千葉県浦安市入船1丁目5−2 プライムタワー新浦安8F", ],
  [ "byOKvy9ixN60ueUw5EbG", "ユニバーサル美容専門学校", "関東地方", "千葉県", "千葉県船橋市本町3丁目5−3", ],
  [ "vJkiHJ9bNh1dLoqRzrCQ", "東洋理容美容専門学校", "関東地方", "千葉県", "千葉県千葉市中央区春日2-17-12", ],
  [ "dN1dw9d0Dx5PU6IijsuY", "パリ総合美容専門学校 千葉校", "関東地方", "千葉県", "千葉県千葉市中央区長洲1丁目15−12", ],
  [ "KM8Wy3XgC8xLKJvknF2D", "千葉ビューティー＆ブライダル専門学校", "関東地方", "千葉県", "千葉県千葉市中央区本千葉町8−16", ],
  [ "pBkj6c0JKDBljxuVJOOG", "千葉美容専門学校", "関東地方", "千葉県", "千葉県千葉市花見川区幕張本郷1丁目2−6", ],
  [ "LF5awJzvgGERqZT66tg1", "大竹高等専修学校", "関東地方", "東京都", "東京都八王子市台町3丁目29−19", ],
  [ "QbHQMESaxuzCVAy9uwTZ", "国際共立学園高等専修学校", "関東地方", "東京都", "東京都荒川区西日暮里2丁目33−23", ],
  [ "87x4NhvCHnMhPFRK8x9T", "すず学園高等専修学校", "関東地方", "東京都", "東京都大田区大森北6丁目13−2", ],
  [ "tpgASRhxIyNM5Goj9qz9", "専門学校 エビスビューティカレッジ", "関東地方", "東京都", "東京都渋谷区恵比寿4丁目19−25", ],
  [ "e6gCCRnFR3Lzxv2ZiilR", "東京文化美容専門学校", "関東地方", "東京都", "東京都江戸川区南小岩6丁目31−10", ],
  [ "8RQvUlIDmtvl2xYgFIbL", "東京マックス美容専門学校", "関東地方", "東京都", "東京都品川区大井1丁目48−11", ],
  [ "acSgIfuuJs5ea86YZNFe", "東京理容専修学校", "関東地方", "東京都", "東京都千代田区西神田1丁目3−4", ],
  [ "seTw4D48BO1tspDAwvNT", "早稲田美容専門学校", "関東地方", "東京都", "東京都新宿区西早稲田2丁目20−7", ],
  [ "dT2PbyTa4de4b1YIpkux", "山野美容芸術短期大学", "関東地方", "東京都", "東京都八王子市鑓水530", ],
  [ "tYW524W2ZfpnVs0tSo6a", "資生堂美容技術専門学校", "関東地方", "東京都", "東京都板橋区加賀2丁目15−1", ],
  [ "ktaE04phmhigHRuOcyd3", "中央理美容専門学校", "関東地方", "東京都", "東京都新宿区下落合2丁目3−16", ],
  [ "eGjvy58TzJPpPL637gmr", "日本美容専門学校", "関東地方", "東京都", "東京都新宿区高田馬場1丁目21−12", ],
  [ "GDOKK1YlHdrGBOA7AnWW", "アポロ美容理容専門学校", "関東地方", "東京都", "東京都八王子市万町23−2", ],
  [ "o77MxFG1nYwwDEPG9eNm", "窪田理容美容専門学校", "関東地方", "東京都", "東京都中野区中野4-11-1", ],
  [ "i7ffvKRAtgtHxFYdwhRw", "国際文化理容美容専門学校 国分寺校", "関東地方", "東京都", "東京都国分寺市南町3丁目2−14", ],
  [ "LJGmxUPO3CgB8zL5b2CB", "国際文化理容美容専門学校 渋谷校", "関東地方", "東京都", "東京都渋谷区神泉町2−2", ],
  [ "iavtPIjjcU2nyJE1xdyC", "国際理容美容専門学校", "関東地方", "東京都", "東京都荒川区東日暮里5-17-8", ],
  [ "e1NBNR6uk20l9GAoc4od", "コーセー美容専門学校", "関東地方", "東京都", "東京都北区堀船1丁目4−13", ],
  [ "rXLM23YpLjZcr94cUm5i", "住田美容専門学校", "関東地方", "東京都", "東京都渋谷区渋谷1丁目21−10", ],
  [ "6z5vGzbkzpmDmRQFXh1o", "タカラ美容専門学校", "関東地方", "東京都", "東京都港区虎ノ門4丁目2−3 虎ノ門トーセイビル 4階", ],
  [ "FlF2FvXevzuGofYRdt0a", "東京総合美容専門学校", "関東地方", "東京都", "東京都豊島区南池袋2丁目8−7", ],
  [ "ZYpfOmilqo30lweTGwuW", "東京ビューティーアート専門学校", "関東地方", "東京都", "東京都文京区本郷3丁目37−8", ],
  [ "eToMlCWOXMAWVmIMLyvZ", "東京ビューティー＆ブライダル専門学校", "関東地方", "東京都", "東京都立川市曙町2丁目19−12", ],
  [ "F4fHovQ4JXJV5vT9H5tx", "東京美容専門学校", "関東地方", "東京都", "東京都新宿区下落合1丁目2−4", ],
  [ "MOGmcbCUTBrZ8BTBlqqv", "東京ベルエポック美容専門学校", "関東地方", "東京都", "東京都江戸川区西葛西6丁目28−16", ],
  [ "1FP22lwFuHqvTpUe5ppg", "東京モード学園", "関東地方", "東京都", "東京都新宿区西新宿1丁目7−3 モード学園総合校舎コクーンタワー", ],
  [ "gl6JG8eEWy9zM0C2GSSS", "ハリウッド美容専門学校", "関東地方", "東京都", "東京都港区六本木6丁目4−4−1", ],
  // [ "Kcsm8UNBVLJqwPRy4gWk", "町田美容専門学校", "関東地方", "東京都", "東京都町田市中町2丁目10−24", ],
  [ "rCLbLKnwb9wO5mDgcLzX", "真野美容専門学校", "関東地方", "東京都", "東京都新宿区歌舞伎町2丁目42−5", ],
  [ "Q3CHXzt8XlBx6N9ylX4p", "マリー・ルイズ美容専門学校", "関東地方", "東京都", "東京都新宿区須賀町3−1", ],
  [ "PyI0otPZGoanLnwJSLTJ", "ミスパリ ビューティ専門学校", "関東地方", "東京都", "東京都豊島区池袋2丁目23−3", ],
  [ "VLrC24emH0JZCFfEagjJ", "山野美容専門学校", "関東地方", "東京都", "東京都渋谷区代々木1丁目53−1", ],
  [ "x4XoKYL2IcQALGpFhqsQ", "ベルエポック美容専門学校 原宿校", "関東地方", "東京都", "東京都渋谷区神宮前3丁目26−1", ],
  [ "WYme5o6oc8JRs0a8RNXM", "アイム湘南美容教育専門学校", "関東地方", "神奈川県", "神奈川県秦野市尾尻536−1", ],
  [ "nppTmVGZNixx4fmFu4GK", "M.D.F BEAUTY COLLEGE", "関東地方", "神奈川県", "神奈川県横浜市都筑区茅ケ崎中央21−6 GATE28 3F4F", ],
  [ "JnKHO2EigFnxAJf0M3il", "鎌倉早見美容芸術専門学校", "関東地方", "神奈川県", "神奈川県鎌倉市小町1丁目2−16 早見芸術学園1号館", ],
  [ "HAP54NSZlvnnZibfwGa9", "国際総合ビューティーカレッジ", "関東地方", "神奈川県", "神奈川県横浜市中区長者町9丁目175番地  第10吉田興産ビル/6階", ],
  [ "W8D8Q4np1U7Jv3UCiMl9", "湘南ビューティカレッジ", "関東地方", "神奈川県", "神奈川県平塚市明石町24−2", ],
  [ "cHJMZrE6YRS1ORB4uWuw", "横浜芸術高等専修学校", "関東地方", "神奈川県", "神奈川県横浜市港北区大豆戸町608−3", ],
  [ "gGj6zs6OOEaftMvBUsYg", "横浜市立横浜商業高等学校別科", "関東地方", "神奈川県", "神奈川県横浜市磯子区丸山1丁目2−21", ],
  [ "NFwoYJSGbpKGQu87LT6B", "アーティスティックＢ横浜美容専門学校", "関東地方", "神奈川県", "神奈川県横浜市西区平沼1丁目38−13", ],
  [ "3RgLZE4YTZh8psWls9PY", "横浜ビューティー＆ブライダル専門学校", "関東地方", "神奈川県", "神奈川県横浜市神奈川区西神奈川1丁目19−6", ],
  [ "hwT1zo12MzkSfb9EgNGO", "神奈川ビューティー＆ビジネス専門学校", "関東地方", "神奈川県", "神奈川県川崎市川崎区渡田向町15−5", ],
  [ "ZA61DNFeweiob6efYR2l", "横浜 ｆ カレッジ", "関東地方", "神奈川県", "神奈川県横浜市西区北幸1丁目2−7", ],
  [ "oRH7szC69FnOBRuStbTP", "横浜理容美容専門学校", "関東地方", "神奈川県", "神奈川県横浜市港北区樽町2丁目6−11", ],
  [ "5joAxp2ECIjqnUOYzy3o", "クレア ヘアモード専門学校", "中部地方", "新潟県", "新潟県長岡市殿町1丁目5−9", ],
  [ "hXRpkcWw304Da0vK8iJp", "国際ビューティモード専門学校", "中部地方", "新潟県", "新潟県新潟市中央区花園1丁目1−12", ],
  [ "Ce8wgWoC3aWSd4GnICLT", "長岡美容専門学校", "中部地方", "新潟県", "新潟県長岡市台町2丁目1−23", ],
  [ "3See1x8mPRPiGsuwLzon", "新潟理容美容専門学校", "中部地方", "新潟県", "新潟県新潟市中央区川岸町2丁目14−3", ],
  [ "8aMgWr8wGcAJDijhYsk1", "臼井美容専門学校", "中部地方", "富山県", "富山県富山市西中野本町7−13", ],
  [ "41bOWUCMsoW3BXWoFOjc", "専門学校 富山ビューティーカレッジ", "中部地方", "富山県", "富山県富山市総曲輪3丁目3−16 総曲輪ウィズビル 2・3階", ],
  [ "4fslCUXVF5okr9f9lxz4", "富山県理容美容専門学校", "中部地方", "富山県", "富山県富山市下新町32−26", ],
  [ "AgkS3E1tBWCCoTTExOS9", "専門学校 金沢美専", "中部地方", "石川県", "石川県金沢市南町6−6−12 国際ビジネス学院ビル", ],
  [ "K1JzZ6hl4iP7GvYrTSQE", "大原スポーツ医療保育福祉専門学校（美容科）", "中部地方", "福井県", "福井県福井市大手2-9-", ],
  [ "hHGhbkJwt58w7SW3umt7", "山梨県美容専門学校", "中部地方", "山梨県", "山梨県甲府市緑が丘2丁目13−36", ],
  [ "3LCuSOjk4aqoxl7qUctm", "長野理容美容専門学校", "中部地方", "長野県", "長野県長野市中御所3丁目11−2", ],
  [ "OJBpKTDDGGDfPnATaup1", "松本理容美容専門学校", "中部地方", "長野県", "長野県松本市宮田11−7", ],
  [ "uYN6ntupbVgmvomaALOP", "岐阜美容専門学校", "中部地方", "岐阜県", "岐阜県岐阜市金園町2丁目1番地", ],
  [ "io602a4NATCKDsGjTaxv", "ベルフォート美容専門学校", "中部地方", "岐阜県", "岐阜県岐阜市橋本町1丁目10−1 アクティブG 2F", ],
  [ "ljrLV91aCM45jAhEhfL6", "池田美容学校", "中部地方", "静岡県", "静岡県静岡市葵区駿府町37", ],
  [ "XEX1ayyK3ppJkWmuIlmc", "静岡県東部総合美容専門学校", "中部地方", "静岡県", "静岡県三島市寿町3−42", ],
  [ "PqxmS0dPCgDVId8vMUM0", "静岡デザイン専門学校", "中部地方", "静岡県", "静岡市葵区御幸町20番地", ],
  [ "bRNT5BS4OO9SbcCJqrdH", "タカヤマ アドバンス ビューティー専門学校", "中部地方", "静岡県", "静岡県富士市松岡1248", ],
  [ "UHuWrL0FAOQFsydMoeub", "浜松クレアックス ビューティーカレッジ", "中部地方", "静岡県", "静岡県浜松市中央区中央1丁目4−15 ＯＧＵＲＩパーキング2 1F", ],
  [ "J38NMgMavHRFnqHz0j0h", "フリーエース美容学校", "中部地方", "静岡県", "静岡県藤枝市前島1丁目7−10", ],
  [ "azVRFNf8Sb17Das1fuIs", "ルネサンス デザイン・美容専門学校", "中部地方", "静岡県", "静岡県浜松市中央区北田町130−12", ],
  [ "UOsFvYfyfMOcBJrZ9uMk", "IG BEAUTY ACADEMY", "中部地方", "愛知県", "愛知県名古屋市東区泉1丁目23−36", ],
  [ "mXnAtsRo05WzBX8hUKSZ", "愛知芸術高等専修学校", "中部地方", "愛知県", "愛知県名古屋市北区山田2丁目2−33", ],
  [ "4O7k7pZYMT0WmrJNrFtG", "アクア理美容学校", "中部地方", "愛知県", "愛知県名古屋市中区新栄2丁目17−2", ],
  [ "NVxR0GBnLAouX0fkhaTU", "アリアーレビューティ専門学校", "中部地方", "愛知県", "愛知県名古屋市千種区今池2丁目1−14", ],
  [ "fNnzHDr0U6RMzO4788Ee", "安城生活福祉高等専修学校", "中部地方", "愛知県", "愛知県安城市相生町5−9", ],
  [ "QzHd3G1EA78zO51KiRga", "セブンティーン美容専門学校", "中部地方", "愛知県", "愛知県豊橋市神明町47−2", ],
  [ "uZhFvwesq5TZU2cgWa4K", "セントラルビューティストカレッジ", "中部地方", "愛知県", "愛知県名古屋市中区松原1丁目13−9", ],
  [ "ccU0xkYaYrOCjDwS8tKH", "専門学校 中部ビューティ・デザイン・デンタルカレッジ","中部地方", "愛知県", "愛知県豊橋市札木町59", ],
  [ "r0tZOyxtkktNTtXBArKi", "MOOビューティーアソシエイション", "中部地方", "愛知県", "愛知県豊橋市八町通3丁目3",  ],
  [ "LSpL93oIxBE2ylmD9rSQ", "名古屋ビューティ専門学校", "中部地方", "愛知県", "愛知県名古屋市東区葵1丁目17−8", ],
  [ "c6vtq8jkA8M436jTYaV2", "名古屋ビューティーアート専門学校", "中部地方", "愛知県", "愛知県名古屋市西区那古野2丁目12−10", ],
  [ "tgVIP6hBvOfDqSEVN6wI", "東海美容学校", "中部地方", "愛知県", "愛知県津島市明天町1丁目26", ],
  [ "Meix2JqVKolaBQW6i2Tm", "名古屋綜合美容専門学校", "中部地方", "愛知県", "愛知県名古屋市中区千代田3丁目21−25", ],
  [ "Qmfl0QvfvjPpm2S5QYmz", "名古屋モード学園", "中部地方", "愛知県", "愛知県名古屋市中村区名駅4丁目27−1 総合校舎スパイラルタワーズ", ],
  [ "4n2QZy2f4xVEkv0nqm7q", "美容専門学校 アーティス・ヘアー・カレッジ", "中部地方", "愛知県", "愛知県豊橋市駅前大通1丁目14 豊橋アーティスビル", ],
  [ "Zuhkwq59ASkuRZ9TItTz", "ビーキュービック美容学校", "中部地方", "愛知県", "愛知県春日井市堀ノ内町2丁目16−15 2F,3F", ],
  [ "uIgHnQkUN9cNc50YWLy1", "旭美容専門学校", "近畿地方", "三重県", "三重県津市上浜町1丁目514", ],
  [ "h7PeF2fIhZR8H0Rk8nu0", "伊勢理容美容専門学校", "近畿地方", "三重県", "三重県伊勢市八日市場町17−27", ],
  [ "14RgeNZxwuaV9mfCty5v", "ミエ・ヘア・アーチストアカデミー", "近畿地方", "三重県", "三重県四日市市羽津中2丁目5−19", ],
  [ "xuHjY5sGbSBFH2YyO6uj", "アミューズ美容専門学校", "近畿地方", "京都府", "京都府京都市南区東九条河辺町30", ],
  [ "oLwExqKuHzD0XmaOmMfF", "京都医健専門学校", "近畿地方", "京都府", "京都府京都市中京区衣棚町51−2", ],
  [ "J43tNPlWxsoeGeSiCAEP", "京都理容美容専修学校", "近畿地方", "京都府", "京都府京都市南区久世上久世町404−2", ],
  [ "zMbtWppDATiPVoZQFcPZ", "YIC京都ビューティ専門学校", "近畿地方", "京都府", "京都府京都市下京区西油小路町27", ],
  [ "LDPKCbm1jWyFIfarnEEA", "アイム・近畿理容美容専門学校", "近畿地方", "大阪府", "大阪府大阪市天王寺区堀越町4−24", ],
  [ "wfZGs8VkrzLBlIBc06gn", "アーデントビューティーカレッジ", "近畿地方", "大阪府", "大阪府大阪市中央区釣鐘町2丁目1−9", ],
  [ "9p67BOYzj5Y5Boj84aJ8", "ヴェールルージュ美容専門学校", "近畿地方", "大阪府", "大阪府大阪市中央区南船場2丁目11−11", ],
  [ "sMDMVw3KtfO0AQovRNZx", "小出美容専門学校大阪校", "近畿地方", "大阪府", "大阪府大阪市浪速区戎本町2丁目10−8", ],
  [ "zGSz6EKAl643XQ0kXHY3", "堺女子短期大学（美容文化コース）", "近畿地方", "大阪府", "堺市西区浜之町1丁目1番1号", ],
  [ "lJw6jb1nJZKRuZotoISn", "理容美容専門学校 西日本ヘアメイクカレッジ", "近畿地方", "大阪府", "大阪府大阪市阿倍野区旭町2丁目1−2 あべのポンテ 2階", ],
  [ "Y4GE3ICwSeWPeXQCSHnN", "ロゼ＆ビューティ美容専門学院", "近畿地方", "大阪府", "大阪府大阪市中央区島之内1丁目21−23 大起興産長堀橋ビル 3F", ],
  [ "eqkOXmgWZxGHsCBhkAh5", "大阪樟蔭女子大学（学芸学部化粧ファッション学科）", "近畿地方", "大阪府", "大阪府東大阪市稲田北3-1-1", ],
  [ "kWE9W0WMnZh4154LtEnr", "大阪ビューティーアート専門学校", "近畿地方", "大阪府", "大阪府大阪市淀川区淀川区西中島3丁目8−29", ],
  [ "w6NAnMKCKHYvEjjZZTOE", "大阪ベルェベル美容専門学校", "近畿地方", "大阪府", "大阪府大阪市北区茶屋町5−10", ],
  [ "mRuVyeBICE7TfFt0qagk", "桂make-upデザイン専門学校", "近畿地方", "大阪府", "大阪府堺市堺区南三国ヶ丘町1丁1−8", ],
  [ "yGBs6OLCbUSjCZx6Y9ay", "ECCアーティスト美容専門学校", "近畿地方", "大阪府", "大阪府大阪市北区中崎西2丁目6−11", ],
  [ "V1sHW8mf6ie35mXi4udn", "大阪モード学園", "近畿地方", "大阪府", "大阪府大阪市北区梅田3丁目3−2", ],
  [ "i21kNVlw1P2oA1EsjEfh", "関西美容専門学校", "近畿地方", "大阪府", "大阪府大阪市中央区天満橋京町2−17", ],
  [ "JPIN8uh6ITJWCOvSuJe3", "高津理容美容専門学校", "近畿地方", "大阪府", "大阪府大阪市中央区日本橋2丁目8−20", ],
  [ "8h2L99d3UoOsfDkKRY0v", "大阪中央理容美容専門学校", "近畿地方", "大阪府", "大阪府大阪市北区天満橋3丁目4−28 大阪理容会館", ],
  [ "CYadEmD5wBzVL68IQHn5", "尼崎理容美容専門学校", "近畿地方", "兵庫県", "兵庫県尼崎市御園町37", ],
  [ "hwVhuD5jJIAXdjQV729D", "神戸ベルェベル美容専門学校", "近畿地方", "兵庫県", "兵庫県神戸市中央区江戸町90", ],
  [ "APuRvpBI2J4OSZG7bNrl", "神戸理容美容専門学校", "近畿地方", "兵庫県", "兵庫県神戸市兵庫区駅前通1丁目3−28", ],
  [ "DpnPUYgge19C2RZZ1TGW", "姫路理容美容専門学校", "近畿地方", "兵庫県", "兵庫県姫路市南駅前町13", ],
  [ "cGeU97xG0rLpgbKxJ2IZ", "BEAUTY ARTS KOBE 日本高等美容専門学校", "近畿地方", "兵庫県", "兵庫県神戸市東灘区御影中町8丁目4−14", ],
  [ "r1Pp19Oc9I7X9MxKmwnb", "彩ビューティカレッジ", "近畿地方", "奈良県", "奈良県奈良市二条町1丁目1−50", ],
  [ "VkT6h2iAk8OP4BqNfI3P", "奈良理容美容専門学校", "近畿地方", "奈良県", "奈良県奈良市西木辻町57−1", ],
  [ "Vunt8UxmterOMC0jrPqI", "IBW美容専門学校", "近畿地方", "和歌山県", "和歌山県和歌山市南汀丁29", ],
  [ "1LF4j1RFv9kjObfXIitn", "和歌山高等美容専門学校", "近畿地方", "和歌山県", "和歌山県和歌山市小人町32", ],
  [ "FrYA8AL9RsKeJEL2wkSK", "鳥取県理容美容専門学校", "中国地方", "鳥取県", "鳥取県鳥取市南吉方1丁目71−3", ],
  [ "5vjAndsZFaDBAKyUDkbg", "島根県立東部高等技術校（美容科）", "中国地方", "島根県", "島根県出雲市長浜町3057－11", ],
  [ "jS9EctlnXaqrPLsw3ueV", "浜田ビューティーカレッジ", "中国地方", "島根県", "島根県浜田市浅井町1429番地20", ],
  [ "LVAPbL6ywZCZk2yXo543", "松江理容美容専門大学校", "中国地方", "島根県", "島根県松江市西津田2丁目15−5", ],
  [ "YbwtxymvEP1SGlLStYPM", "岡山県理容美容専門学校", "中国地方", "岡山県", "岡山県岡山市北区大元2丁目6番5号", ],
  [ "qS0128i1d45T608B3tcS", "専門学校 岡山ビューティモード", "中国地方", "岡山県", "岡山県岡山市北区昭和町3−12", ],
  [ "VeyZaHulNb2OQJCjT1Fb", "専門学校 倉敷ビューティーカレッジ", "中国地方", "岡山県", "岡山県倉敷市寿町10−5", ],
  [ "VTSBWCCXiqRT5HFxXP2b", "専門学校 マインドビューティーカレッジ", "中国地方", "広島県", "広島県広島市中区大手町3丁目8−11", ],
  [ "XT5erCPlqZH9njCfqxWj", "広島県東部美容専門学校", "中国地方", "広島県", "広島県福山市西町2丁目16−15", ],
  [ "K0yCxoTapNSDNAisj63V", "広島県理容美容専門学校", "中国地方", "広島県", "広島県広島市中区国泰寺町1丁目8−24", ],
  [ "6MM1RxsDZWlgmG2GYU8K", "広島ビューティ＆ブライダル専門学校", "中国地方", "広島県", "広島市南区松原町10-26", ],
  [ "SbvvYyYYe3SbvBP95dDN", "広島美容専門学校", "中国地方", "広島県", "島県広島市中区千田町3丁目15−1", ],
  [ "NIySFf1xZXUNQoteSgZT", "下関理容美容専門学校", "中国地方", "山口県", "山口県下関市貴船町3丁目12−14", ],
  [ "rmb2QUw1saztDI2yBxAf", "東亜大学 芸術学部（トータルビューティ学科）", "中国地方", "山口県", "山口県下関市一の宮学園町2-1", ],
  [ "fxpZPB0TRyZD5bby4iGM", "山口県理容美容専門学校", "中国地方", "山口県", "山口県山口市小郡長谷1丁目5番30号", ],
  [ "F7Lbqt09P0IybNtkpftH", "YICビューティモード専門学校", "中国地方", "山口県", "山口県山口市小郡黄金町2−24", ],
  [ "3tqGLGGgtWDhAFdtt4Sb", "専門学校 徳島穴吹カレッジ", "四国地方", "徳島県", "徳島県徳島市徳島町2丁目20", ],
  [ "LKV2AUJiL0eoKDXwMmgT", "徳島県立中央テクノスクール", "四国地方", "徳島県", "徳島県徳島市南末広町5−23−64", ],
  [ "14TlLSYB9lo5RcQS892H", "専修学校 香川県美容学校", "四国地方", "香川県", "香川県高松市松縄町1091番地3", ],
  [ "WxQKGVSMhRTqPJtRpPib", "一般社団法人 宇和島美容学校", "四国地方", "愛媛県", "愛媛県宇和島市新町1丁目5−28", ],
  [ "JwwApkvYXKxCjBBk6F4I", "愛媛県美容専門学校", "四国地方", "愛媛県", "愛媛県松山市小栗6丁目1−26", ],
  [ "Q4l9vTRspufFXeqQmIQN", "河原ビューティモード専門学校", "四国地方", "愛媛県", "愛媛県松山市一番町1丁目1−1", ],
  [ "lXFmoeazrJzBxL8xXlVA", "東予理容美容専門学校", "四国地方", "愛媛県", "愛媛県新居浜市若水町2丁目3−44", ],
  [ "EIG6RulpwIVOwtNBqChP", "高知理容美容専門学校", "四国地方", "高知県", "高知県高知市中万々85−3", ],
  [ "QuNxqlY5901YHDHOtO3W", "龍馬デザイン・ビューティ専門学校", "四国地方", "高知県", "高知県高知市旭町2丁目2−58", ],
  [ "AAwV5TFVIEbaszvfDjue", "飯塚理容美容専門学校", "九州地方", "福岡県", "福岡県飯塚市1748", ],
  [ "rRa3XX6dGP6aq3fQKPzy", "大村美容ファッション専門学校", "九州地方", "福岡県", "福岡県福岡市中央区黒門2-6 アメリカ領事館通り", ],
  [ "mBATlYgBnkJCLxP2OU94", "九州CTB理容美容専門学校", "九州地方", "福岡県", "福岡県北九州市八幡東区西本町2丁目2−1", ],
  [ "a1tUIIUKA4IkyO7jFZ1Z", "福岡南美容専門学校", "九州地方", "福岡県", "福岡県久留米市花畑1丁目1−1", ],
  [ "n5YKW70V5rlwFOJKlRty", "福岡ビューティーアート専門学校", "九州地方", "福岡県", "福岡県福岡市博多区博多駅東1丁目16−28", ],
  [ "mNdeNGuiAE6Ug3LnYmVA", "福岡理容美容専門学校", "九州地方", "福岡県", "福岡県福岡市中央区大名2丁目2−9", ],
  [ "0aZMArIb56ssOpr6ozVW", "福岡美容専門学校 北九州校", "九州地方", "福岡県", "福岡県北九州市小倉北区上富野1丁目5−59 ＦＵＫＵＢＩ", ],
  [ "DfmCZFooUnfJKx7jZOCt", "福岡ベルエポック美容専門学校", "九州地方", "福岡県", "福岡県福岡市博多区大博町4−17", ],
  [ "XRutNeztkn5UOk90QjEl", "福岡美容専門学校 福岡校", "九州地方", "福岡県", "福岡県福岡市中央区荒戸2丁目3−12", ],
  [ "akS6VWLACDomgMPipyuC", "ハリウッドワールド美容専門学校", "九州地方", "福岡県", "福岡県柳川市三橋町柳河55−1", ],
  [ "tLa0Xi5FzSwCWSVEDWyy", "アイビービューティカレッジ", "九州地方", "佐賀県", "佐賀県佐賀市伊勢町4−4", ],
  [ "VnZV90LKG9eZBhSq1zOR", "エッジ国際美容専門学校", "九州地方", "佐賀県", "佐賀県佐賀市唐人2丁目2−9", ],
  [ "WikfkTntvvuaKWv75iXL", "長崎県美容専門学校", "九州地方", "長崎県", "長崎県長崎市桜馬場1丁目9−10", ],
  [ "gYxxfxdFZaL8s7lpXYWj", "九州美容専門学校", "九州地方", "熊本県", "熊本県熊本市中央区南坪井町10−28", ],
  [ "ATGhhbJQrVAvqHCzk4oh", "熊本ベルェベル美容専門学校", "九州地方", "熊本県", "熊本県熊本市中央区紺屋今町2−18", ],
  [ "5oYDvtj7YLjkBOWmvDHk", "専修学校 モア・ヘアメイクカレッジ", "九州地方", "熊本県", "熊本県熊本市中央区本山4丁目1−46", ],
  [ "hayxCF45JxnK1QBHukUD", "八代実業専門学校（美容師養成科）", "九州地方", "熊本県", "熊本県八代市迎町1丁目16−33", ],
  [ "ne2tZIXJj649UVo2wbps", "明日香美容文化専門大学校", "九州地方", "大分県", "大分県大分市東大道1丁目4−2", ],
  [ "4JGIhsOWf3sdqqwRvcZO", "アンビシャス国際美容学校", "九州地方", "大分県", "大分県大分市市551", ],
  [ "wxZgJ9OPLX5vpo1JLUnj", "明星国際ビューティカレッジ", "九州地方", "大分県", "大分県大分市大津町1丁目1−1", ],
  [ "sAt2Qe3Wk3Ip6cgJ67Om", "宮崎サザンビューティ美容専門学校", "九州地方", "宮崎県", "宮崎県宮崎市老松2-1-17", ],
  [ "gsPFafkYbV3qnbXFKtbJ", "宮崎美容専門学校", "九州地方", "宮崎県", "宮崎県宮崎市橘通東1丁目7−13", ],
  [ "hYbe0qWTjB86OzXmIiZk", "赤塚学園美容・デザイン専門学校", "九州地方", "鹿児島県", "鹿児島県鹿児島市上荒田町6−1", ],
  [ "6THhik5RN6onNELpaVKT", "鹿児島県理容美容専門学校", "九州地方", "鹿児島県", "鹿児島県鹿児島市加治屋町17−7", ],
  [ "iueAUb3ULvJelAEQEk9Z", "鹿児島レディスカレッジ", "九州地方", "鹿児島県", "鹿児島県鹿児島市加治屋町12−9", ],
  [ "6Eyg3yjkYCZvMeePSm6X", "沖縄ビューティー＆ブライダル専門学校", "九州地方", "沖縄県", "沖縄県那覇市上之屋1丁目3−13", ],
  [ "moy24zTUK6wRKhhPnaZU", "専修学校 ビューティーモードカレッジ", "九州地方", "沖縄県", "沖縄県那覇市東町23-5", ],
  [ "IwnDrOxHQrs6aZ3IPzBw", "大育理容美容専門学校", "九州地方", "沖縄県", "沖縄県那覇市大道5−1", ]
];

export const schoolsId: string[] = [
  "VfebuLLVlIKQn7SDLaPi",
  "c87VPc8ARZ1E0pSBhnlA",
  "jzUhkTvs0ROAgaYloreE",
  "BdvuP42vpg0Ppose979M",
  "hWIzPALhrxEkEXgMjt3z",
  "jKm8xuwcsiFSljYGCUvU",
  "MofURROGF27Lq2p6sSw1",
  "Y3AidQXu73G7txj8PEL2",
  "3ZDstghMiT21lb3Vw6e2",
  "ZriYgbF6TZ41urRdfnB6",
  "kXMuwn9Mu7u8486FhByx",
  "Na1bKvJvqTITwzkM1WDN",
  "MemszPsG5zDbV84NGHb7",
  "0DhIG7oWH4oaxdG3lukL",
  "mTlwQJAtO6RQyFSk4RLV",
  "TDgV6labPoDRybBCaNxU",
  "9MaS5ffvRmNqcPXMIykl",
  "RREXrEtZg9l1Uq2wERPc",
  "BvUO0uhDuZpXgk9vWOZZ",
  "VNRr0kUxBq5jfekmGkHs",
  "e2DleRJ4AuGWo0xcRetv",
  "8VYvgL6kjAYzW8I3pDSB",
  "D95fBLqqMQjBEBjskxOh",
  "FbpzLDkBue3AYWqsW1Q0",
  "sI2DhkAxlX6IR0LpTZPE",
  "3YTlV2kxCKne5pjmVm52",
  "ddsrIzN8aICLALM2lMfh",
  "aMOUuPUFXUhQHx0bz83o",
  "q1V2KWDwuYFKBWwiaBeB",
  "7Pc5DYytT8PZ0y1OGdq9",
  "yLwrhytwPGiyYY0OXfoK",
  "A8YIMPoYT2WE4RrQrdBs",
  "DDXrF6fHdPIz2Fg9HuwR",
  "3ATZ6MDyoU3kDxcicadG",
  "UuET1ZfWHR7bUpQ64Y27",
  "xTqyKDPmbcGR5j8kzOpP",
  "tiGHP8QE07PslpKRgsci",
  "Gx1Q3DUMCDOYySu9OEcV",
  "JG9H4eB0gJ7sSEbtiChU",
  "E0gUdLXYpDTsVNd15f5R",
  "2sx4vihNwgiTz9nzVme0",
  "MxSQs9bwBch4Ytx055mZ",
  "x6SpRReATnc0iXf9bSfC",
  "CoU0be0nh5mfNa9M90U0",
  "JRisP4ReWHRadroYIznI",
  "tjmxE2PTfRYxFow9eG4O",
  "byOKvy9ixN60ueUw5EbG",
  "vJkiHJ9bNh1dLoqRzrCQ",
  "dN1dw9d0Dx5PU6IijsuY",
  "KM8Wy3XgC8xLKJvknF2D",
  "pBkj6c0JKDBljxuVJOOG",
  "LF5awJzvgGERqZT66tg1",
  "QbHQMESaxuzCVAy9uwTZ",
  "87x4NhvCHnMhPFRK8x9T",
  "tpgASRhxIyNM5Goj9qz9",
  "e6gCCRnFR3Lzxv2ZiilR",
  "8RQvUlIDmtvl2xYgFIbL",
  "acSgIfuuJs5ea86YZNFe",
  "seTw4D48BO1tspDAwvNT",
  "dT2PbyTa4de4b1YIpkux",
  "tYW524W2ZfpnVs0tSo6a",
  "ktaE04phmhigHRuOcyd3",
  "eGjvy58TzJPpPL637gmr",
  "GDOKK1YlHdrGBOA7AnWW",
  "o77MxFG1nYwwDEPG9eNm",
  "i7ffvKRAtgtHxFYdwhRw",
  "LJGmxUPO3CgB8zL5b2CB",
  "iavtPIjjcU2nyJE1xdyC",
  "e1NBNR6uk20l9GAoc4od",
  "rXLM23YpLjZcr94cUm5i",
  "6z5vGzbkzpmDmRQFXh1o",
  "FlF2FvXevzuGofYRdt0a",
  "ZYpfOmilqo30lweTGwuW",
  "eToMlCWOXMAWVmIMLyvZ",
  "F4fHovQ4JXJV5vT9H5tx",
  "MOGmcbCUTBrZ8BTBlqqv",
  "1FP22lwFuHqvTpUe5ppg",
  "gl6JG8eEWy9zM0C2GSSS",
  "Kcsm8UNBVLJqwPRy4gWk",
  "rCLbLKnwb9wO5mDgcLzX",
  "Q3CHXzt8XlBx6N9ylX4p",
  "PyI0otPZGoanLnwJSLTJ",
  "VLrC24emH0JZCFfEagjJ",
  "x4XoKYL2IcQALGpFhqsQ",
  "WYme5o6oc8JRs0a8RNXM",
  "nppTmVGZNixx4fmFu4GK",
  "JnKHO2EigFnxAJf0M3il",
  "HAP54NSZlvnnZibfwGa9",
  "W8D8Q4np1U7Jv3UCiMl9",
  "cHJMZrE6YRS1ORB4uWuw",
  "gGj6zs6OOEaftMvBUsYg",
  "NFwoYJSGbpKGQu87LT6B",
  "3RgLZE4YTZh8psWls9PY",
  "hwT1zo12MzkSfb9EgNGO",
  "ZA61DNFeweiob6efYR2l",
  "oRH7szC69FnOBRuStbTP",
  "5joAxp2ECIjqnUOYzy3o",
  "hXRpkcWw304Da0vK8iJp",
  "Ce8wgWoC3aWSd4GnICLT",
  "3See1x8mPRPiGsuwLzon",
  "8aMgWr8wGcAJDijhYsk1",
  "41bOWUCMsoW3BXWoFOjc",
  "4fslCUXVF5okr9f9lxz4",
  "AgkS3E1tBWCCoTTExOS9",
  "K1JzZ6hl4iP7GvYrTSQE",
  "hHGhbkJwt58w7SW3umt7",
  "3LCuSOjk4aqoxl7qUctm",
  "OJBpKTDDGGDfPnATaup1",
  "uYN6ntupbVgmvomaALOP",
  "io602a4NATCKDsGjTaxv",
  "ljrLV91aCM45jAhEhfL6",
  "XEX1ayyK3ppJkWmuIlmc",
  "PqxmS0dPCgDVId8vMUM0",
  "bRNT5BS4OO9SbcCJqrdH",
  "UHuWrL0FAOQFsydMoeub",
  "J38NMgMavHRFnqHz0j0h",
  "azVRFNf8Sb17Das1fuIs",
  "UOsFvYfyfMOcBJrZ9uMk",
  "mXnAtsRo05WzBX8hUKSZ",
  "4O7k7pZYMT0WmrJNrFtG",
  "NVxR0GBnLAouX0fkhaTU",
  "fNnzHDr0U6RMzO4788Ee",
  "QzHd3G1EA78zO51KiRga",
  "uZhFvwesq5TZU2cgWa4K",
  "ccU0xkYaYrOCjDwS8tKH",
  "r0tZOyxtkktNTtXBArKi",
  "LSpL93oIxBE2ylmD9rSQ",
  "c6vtq8jkA8M436jTYaV2",
  "tgVIP6hBvOfDqSEVN6wI",
  "Meix2JqVKolaBQW6i2Tm",
  "BP8sl2CH4iLFrIX48Nsn",
  "Qmfl0QvfvjPpm2S5QYmz",
  "4n2QZy2f4xVEkv0nqm7q",
  "Zuhkwq59ASkuRZ9TItTz",
  "uIgHnQkUN9cNc50YWLy1",
  "h7PeF2fIhZR8H0Rk8nu0",
  "14RgeNZxwuaV9mfCty5v",
  "xuHjY5sGbSBFH2YyO6uj",
  "oLwExqKuHzD0XmaOmMfF",
  "J43tNPlWxsoeGeSiCAEP",
  "zMbtWppDATiPVoZQFcPZ",
  "LDPKCbm1jWyFIfarnEEA",
  "wfZGs8VkrzLBlIBc06gn",
  "9p67BOYzj5Y5Boj84aJ8",
  "sMDMVw3KtfO0AQovRNZx",
  "zGSz6EKAl643XQ0kXHY3",
  "lJw6jb1nJZKRuZotoISn",
  "Y4GE3ICwSeWPeXQCSHnN",
  "eqkOXmgWZxGHsCBhkAh5",
  "kWE9W0WMnZh4154LtEnr",
  "w6NAnMKCKHYvEjjZZTOE",
  "mRuVyeBICE7TfFt0qagk",
  "yGBs6OLCbUSjCZx6Y9ay",
  "V1sHW8mf6ie35mXi4udn",
  "i21kNVlw1P2oA1EsjEfh",
  "JPIN8uh6ITJWCOvSuJe3",
  "8h2L99d3UoOsfDkKRY0v",
  "CYadEmD5wBzVL68IQHn5",
  "hwVhuD5jJIAXdjQV729D",
  "APuRvpBI2J4OSZG7bNrl",
  "DpnPUYgge19C2RZZ1TGW",
  "cGeU97xG0rLpgbKxJ2IZ",
  "r1Pp19Oc9I7X9MxKmwnb",
  "VkT6h2iAk8OP4BqNfI3P",
  "Vunt8UxmterOMC0jrPqI",
  "1LF4j1RFv9kjObfXIitn",
  "FrYA8AL9RsKeJEL2wkSK",
  "5vjAndsZFaDBAKyUDkbg",
  "jS9EctlnXaqrPLsw3ueV",
  "LVAPbL6ywZCZk2yXo543",
  "YbwtxymvEP1SGlLStYPM",
  "qS0128i1d45T608B3tcS",
  "VeyZaHulNb2OQJCjT1Fb",
  "VTSBWCCXiqRT5HFxXP2b",
  "XT5erCPlqZH9njCfqxWj",
  "K0yCxoTapNSDNAisj63V",
  "6MM1RxsDZWlgmG2GYU8K",
  "SbvvYyYYe3SbvBP95dDN",
  "NIySFf1xZXUNQoteSgZT",
  "rmb2QUw1saztDI2yBxAf",
  "fxpZPB0TRyZD5bby4iGM",
  "F7Lbqt09P0IybNtkpftH",
  "3tqGLGGgtWDhAFdtt4Sb",
  "LKV2AUJiL0eoKDXwMmgT",
  "14TlLSYB9lo5RcQS892H",
  "WxQKGVSMhRTqPJtRpPib",
  "JwwApkvYXKxCjBBk6F4I",
  "Q4l9vTRspufFXeqQmIQN",
  "lXFmoeazrJzBxL8xXlVA",
  "EIG6RulpwIVOwtNBqChP",
  "QuNxqlY5901YHDHOtO3W",
  "AAwV5TFVIEbaszvfDjue",
  "rRa3XX6dGP6aq3fQKPzy",
  "mBATlYgBnkJCLxP2OU94",
  "a1tUIIUKA4IkyO7jFZ1Z",
  "n5YKW70V5rlwFOJKlRty",
  "mNdeNGuiAE6Ug3LnYmVA",
  "0aZMArIb56ssOpr6ozVW",
  "DfmCZFooUnfJKx7jZOCt",
  "XRutNeztkn5UOk90QjEl",
  "akS6VWLACDomgMPipyuC",
  "tLa0Xi5FzSwCWSVEDWyy",
  "VnZV90LKG9eZBhSq1zOR",
  "WikfkTntvvuaKWv75iXL",
  "gYxxfxdFZaL8s7lpXYWj",
  "ATGhhbJQrVAvqHCzk4oh",
  "5oYDvtj7YLjkBOWmvDHk",
  "hayxCF45JxnK1QBHukUD",
  "ne2tZIXJj649UVo2wbps",
  "4JGIhsOWf3sdqqwRvcZO",
  "wxZgJ9OPLX5vpo1JLUnj",
  "sAt2Qe3Wk3Ip6cgJ67Om",
  "gsPFafkYbV3qnbXFKtbJ",
  "hYbe0qWTjB86OzXmIiZk",
  "6THhik5RN6onNELpaVKT",
  "iueAUb3ULvJelAEQEk9Z",
  "6Eyg3yjkYCZvMeePSm6X",
  "moy24zTUK6wRKhhPnaZU",
  "IwnDrOxHQrs6aZ3IPzBw",
]

export type SchoolData = {
  name: string;
  school: string;
  class: string;
  grade: string;
  department: string;
};

export const defaultSchoolData: SchoolData = {
  name: "",
  school: "",
  class: "",
  grade: "",
  department: "",
};

export const formatSchoolData = (data: any): SchoolData => ({
  ...defaultSchoolData,
  name: data?.name ?? "",
  school: data?.school ?? "",
  class: data?.class ?? "",
  grade: data?.grade ?? "",
  department: data?.department ?? "",
});

export type ResumeData = {
  isCompleted: boolean;
  resumeCompleteness: number;
};

export const defaultResumeData: ResumeData = {
  isCompleted: false,
  resumeCompleteness: 0,
};

export const formatResumeData = (data: any): ResumeData => ({
  ...defaultResumeData,
  isCompleted: data?.isCompleted ?? false,
  resumeCompleteness: data?.resumeCompleteness ?? 0,
});

export type JobOfferData = {
  isCompleted: boolean;
  report: boolean;
};

export const defaultJobOfferData: JobOfferData = {
  isCompleted: false,
  report: false,
};

export const formatJobOfferData = (data: any): JobOfferData => ({
  ...defaultJobOfferData,
  isCompleted: data?.isCompleted ?? false,
  report: data?.report ?? false,
});

export type SchoolUserData = {
  uid: string;

  profile: {
    name: string;
    text: string;
    business: string;
    badge: number;
    color: string;
    sns: {
      instagram: string;
      tiktok: string;
    };
  };

  education: {
    name: string;
    school: string;
    department: string;
    grade: string;
    class: string;
    number: string;
  };

  activity: {
    styleSaves: string[];
    recruitSaves: string[];
    recruitApplyList: string[];
    recruitVisitList: string[];
    resume: boolean;
    report: boolean;
  };
  
  analytics: {
    pvCount: number;
    applyStatusCount: {
      志望先: number,
      応募済み: number,
      内定承諾: number,
      辞退: number,
      不合格: number,
    };
    postCount: number;
  };
};

export const defaultSchoolUserData: SchoolUserData = {
  uid: "",

  profile: {
    name: "",
    text: "",
    business: "美容学生",
    badge: 0,
    color: "#2F3E4C",
    sns: {
      instagram: "",
      tiktok: "",
    },
  },

  education: {
    name: "",
    school: "",
    department: "",
    grade: "",
    class: "",
    number: "",
  },

  activity: {
    styleSaves: [],
    recruitSaves: [],
    recruitApplyList: [],
    recruitVisitList: [],
    resume: false,
    report: false,
  },
  
  analytics: {
    pvCount: 0,
    applyStatusCount: {
      志望先: 0,
      応募済み: 0,
      内定承諾: 0,
      辞退: 0,
      不合格: 0,
    },
    postCount: 0,
  },
};

export const formatSchoolUserData = (docData: any, id: string): SchoolUserData => ({
  ...defaultSchoolUserData,

  uid: docData?.uid ?? "",

  profile: {
    name: docData?.profile?.name ?? "",
    text: docData?.profile?.text ?? "",
    business: docData?.profile?.business ?? "美容学生",
    badge: docData?.profile?.badge ?? 0,
    color: docData?.profile?.color ?? "#2F3E4C",
    sns: {
      instagram: docData?.profile?.sns?.instagram ?? "",
      tiktok: docData?.profile?.sns?.tiktok ?? "",
    },
  },

  education: {
    name: docData?.education?.name ?? "",
    school: docData?.education?.school ?? "",
    department: docData?.education?.department ?? "",
    grade: docData?.education?.grade ?? "",
    class: docData?.education?.class ?? "",
    number: docData?.education?.number ?? "",
  },

  activity: {
    styleSaves: docData?.activity?.styleSaves ?? [],
    recruitSaves: docData?.activity?.recruitSaves ?? [],
    recruitApplyList: docData?.activity?.recruitApplyList ?? [],
    recruitVisitList: docData?.activity?.recruitVisitList ?? [],
    resume: docData?.activity?.resume ?? false,
    report: docData?.activity?.report ?? false,
  },

  analytics: {
    pvCount: docData?.analytics?.pvCount ?? 0,
    applyStatusCount: {
      志望先: docData?.analytics?.applyStatusCount?.志望先 ?? 0,
      応募済み: docData?.analytics?.applyStatusCount?.応募済み ?? 0,
      内定承諾: docData?.analytics?.applyStatusCount?.内定承諾 ?? 0,
      辞退: docData?.analytics?.applyStatusCount?.辞退 ?? 0,
      不合格: docData?.analytics?.applyStatusCount?.不合格 ?? 0,
    },
    postCount: docData?.analytics?.postCount ?? 0,
  },
});



// export type SchoolInfoData = {
//   class: string[];
//   grade: string[];
//   department: string[];
// };

// export const defaultSchoolInfoData: SchoolInfoData = {
//   class: [],
//   grade: [],
//   department: [],
// };

// export const formatSchoolInfoData = (data: any): SchoolInfoData => ({
//   ...defaultSchoolInfoData,
//   class: data?.class ?? [],
//   grade: data?.grade ?? [],
//   department: data?.department ?? [],
// });



export const normalizeFirestoreDate = (value: any): FirestoreDate => {
  if (!value) return new Date();
  if (value instanceof Date) return value;
  if (typeof value?.toDate === "function") return value;
  return new Date();
};

export type YearMonthText = {
  years: string;
  month: string;
  text: string;
};

export const defaultYearMonthText: YearMonthText = {
  years: "",
  month: "",
  text: "",
};

export type Awards = {
  award1: YearMonthText;
  award2: YearMonthText;
  award3: YearMonthText;
  isCompleted: boolean;
  time: FirestoreDate;
};

export const defaultAwards: Awards = {
  award1: defaultYearMonthText,
  award2: defaultYearMonthText,
  award3: defaultYearMonthText,
  isCompleted: false,
  time: new Date(),
};

export const formatAwards = (data: any): Awards => ({
  ...defaultAwards,
  award1: data?.award1 ?? defaultYearMonthText,
  award2: data?.award2 ?? defaultYearMonthText,
  award3: data?.award3 ?? defaultYearMonthText,
  isCompleted: data?.isCompleted ?? false,
  time: normalizeFirestoreDate(data?.time),
});

export type Address = {
  postcode: string;
  address: string;
  addressHurigana: string;
};

export type Birthday = {
  year: string;
  month: string;
  day: string;
};

export type BasicInfo = {
  name: string;
  nameHurigana: string;
  sex: string;
  age: string;
  bloodType: string;
  mail: string;
  phone: string;
  idImageUrl: string;
  address: Address;
  birthday: Birthday;
  socialMedia: SocialMedia;
  isCompleted: boolean;
};

export const defaultBasicInfo: BasicInfo = {
  name: "",
  nameHurigana: "",
  sex: "",
  age: "",
  bloodType: "",
  mail: "",
  phone: "",
  idImageUrl: "",
  address: {
    postcode: "",
    address: "",
    addressHurigana: "",
  },
  birthday: {
    year: "",
    month: "",
    day: "",
  },
  socialMedia: {
    instagram: "",
    instagramFollower: "",
    tiktok: "",
    tiktokFollower: "",
    twitter: "",
    twitterFollower: "",
  },
  isCompleted: false,
};

export const formatBasicInfo = (data: any): BasicInfo => ({
  ...defaultBasicInfo,
  ...data,
  address: {
    ...defaultBasicInfo.address,
    ...data?.address,
  },
  birthday: {
    ...defaultBasicInfo.birthday,
    ...data?.birthday,
  },
  socialMedia: {
    ...defaultBasicInfo.socialMedia,
    ...data?.socialMedia,
  },
});

export type SocialMedia = {
  instagram: string;
  instagramFollower: string;
  tiktok: string;
  tiktokFollower: string;
  twitter: string;
  twitterFollower: string;
};

export const defaultSocialMedia: SocialMedia = {
  instagram: "",
  instagramFollower: "",
  tiktok: "",
  tiktokFollower: "",
  twitter: "",
  twitterFollower: "",
};

export const formatSocialMedia = (data: any): SocialMedia => ({
  ...defaultSocialMedia,
  ...data,
  // time: normalizeFirestoreDate(data?.time),
});

export type CoordinateItem = {
  title: string;
  point: string;
  fileUrl: string | null;
};

export type Coordinates = {
  coordinate1: CoordinateItem;
  coordinate2: CoordinateItem;
  coordinate3: CoordinateItem;
  isCompleted: boolean;
};

const defaultCoordinateItem: CoordinateItem = {
  title: "",
  point: "",
  fileUrl: null,
};

export const defaultCoordinates: Coordinates = {
  coordinate1: defaultCoordinateItem,
  coordinate2: defaultCoordinateItem,
  coordinate3: defaultCoordinateItem,
  isCompleted: false,
};

export const formatCoordinates = (data: any): Coordinates => ({
  ...defaultCoordinates,
  coordinate1: data?.coordinate1 ?? defaultCoordinateItem,
  coordinate2: data?.coordinate2 ?? defaultCoordinateItem,
  coordinate3: data?.coordinate3 ?? defaultCoordinateItem,
  isCompleted: data?.isCompleted ?? false,
});

export type Histories = {
  history1: YearMonthText;
  history2: YearMonthText;
  history3: YearMonthText;
  history4: YearMonthText;
  history5: YearMonthText;
  history6: YearMonthText;
  isCompleted: boolean;
  time: FirestoreDate;
};

export const defaultHistories: Histories = {
  history1: defaultYearMonthText,
  history2: defaultYearMonthText,
  history3: defaultYearMonthText,
  history4: defaultYearMonthText,
  history5: defaultYearMonthText,
  history6: defaultYearMonthText,
  isCompleted: false,
  time: new Date(),
};

export const formatHistories = (data: any): Histories => ({
  ...defaultHistories,
  ...data,
  time: normalizeFirestoreDate(data?.time),
});

export type MotivationPr = {
  motivation: string;
  prText: string;
  isCompleted: boolean;
  time: FirestoreDate;
};

export const defaultMotivationPr: MotivationPr = {
  motivation: "",
  prText: "",
  isCompleted: false,
  time: new Date(),
};

export const formatMotivationPr = (data: any): MotivationPr => ({
  ...defaultMotivationPr,
  ...data,
  time: normalizeFirestoreDate(data?.time),
});

export type OtherDocuments = {
  document1: string | null;
  document2: string | null;
  document3: string | null;
  isCompleted: boolean;
};

export const defaultOtherDocuments: OtherDocuments = {
  document1: null,
  document2: null,
  document3: null,
  isCompleted: false,
};

export const formatOtherDocuments = (data: any): OtherDocuments => ({
  ...defaultOtherDocuments,
  ...data,
});

export type Questions = {
  question01: string;
  question02: string;
  question03: string;
  questionCount: number;
  isCompleted: boolean;
};

export const defaultQuestions: Questions = {
  question01: "",
  question02: "",
  question03: "",
  questionCount: 0,
  isCompleted: false,
};

export const formatQuestions = (data: any): Questions => ({
  ...defaultQuestions,
  ...data,
});

export type Applicant = {
  id: string;
  uid: string;
  companyId: string;
  recruitId: string;
  status: boolean;
  time: FirestoreDate;

  awards: Awards;
  basicInfo: BasicInfo;
  // socialMedia: SocialMedia;
  coordinates: Coordinates;
  histories: Histories;
  motivationPr: MotivationPr;
  otherDocuments: OtherDocuments;
  questions: Questions;
};

export const formatApplicant = (
  snap: DocumentSnapshot<DocumentData>
): Applicant => {
  const data = snap.data();
  if (!data) throw new Error("Applicant data is undefined");

  return {
    id: snap.id,
    uid: data.uid ?? "",
    companyId: data.companyId ?? "",
    recruitId: data.recruitId ?? "",
    status: data.status ?? false,
    time: normalizeFirestoreDate(data.time),

    awards: formatAwards(data.awards),
    basicInfo: formatBasicInfo(data.basicInfo),
    // socialMedia: formatSocialMedia(data.socialMedia),
    coordinates: formatCoordinates(data.coordinates),
    histories: formatHistories(data.histories),
    motivationPr: formatMotivationPr(data.motivationPr),
    otherDocuments: formatOtherDocuments(data.otherDocuments),
    questions: formatQuestions(data.questions),
  };
};

export const defaultApplicant: Applicant = {
  id: "",
  uid: "",
  companyId: "",
  recruitId: "",
  status: false,
  time: new Date(),

  awards: {
    award1: { years: "", month: "", text: "" },
    award2: { years: "", month: "", text: "" },
    award3: { years: "", month: "", text: "" },
    isCompleted: false,
    time: new Date(),
  },

  basicInfo: {
    name: "",
    nameHurigana: "",
    sex: "",
    age: "",
    bloodType: "",
    mail: "",
    phone: "",
    idImageUrl: "",
    address: {
      postcode: "",
      address: "",
      addressHurigana: "",
    },
    birthday: {
      year: "",
      month: "",
      day: "",
    },
    socialMedia: {
      instagram: "",
      instagramFollower: "",
      tiktok: "",
      tiktokFollower: "",
      twitter: "",
      twitterFollower: "",
    },
    isCompleted: false,
  },

  coordinates: {
    coordinate1: { title: "", point: "", fileUrl: null },
    coordinate2: { title: "", point: "", fileUrl: null },
    coordinate3: { title: "", point: "", fileUrl: null },
    isCompleted: false,
  },

  histories: {
    history1: { years: "", month: "", text: "" },
    history2: { years: "", month: "", text: "" },
    history3: { years: "", month: "", text: "" },
    history4: { years: "", month: "", text: "" },
    history5: { years: "", month: "", text: "" },
    history6: { years: "", month: "", text: "" },
    isCompleted: false,
    time: new Date(),
  },

  motivationPr: {
    motivation: "",
    prText: "",
    isCompleted: false,
    time: new Date(),
  },

  otherDocuments: {
    document1: null,
    document2: null,
    document3: null,
    isCompleted: false,
  },

  questions: {
    question01: "",
    question02: "",
    question03: "",
    questionCount: 0,
    isCompleted: false,
  },
};
